
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable react/no-unescaped-entities */
import { Box, List, ListItem } from "@mui/material";
import { Grid, Typography, Meta } from "@/components/core";
export default function Index() {
    return (<Box sx={{
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            paddingTop: "29px",
            width: "100%",
        }}>
      <Grid sx={{
            maxWidth: "940px !important",
            mx: "auto",
            color: "#545454",
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "1px",
            "& p": {
                fontFamily: "Manrope, sans-serif",
                fontSize: "14px",
                lineHeight: "20px",
                marginBottom: "10px",
                letterSpacing: 0,
            },
            "& li": {
                fontFamily: "Manrope, sans-serif",
                fontSize: "14px",
                lineHeight: "20px",
                pb: 0,
                letterSpacing: 0,
            },
            "& h2": {
                marginTop: "0",
                marginBottom: "0",
                fontSize: "42px",
                fontWeight: "400",
                lineHeight: "44px",
                "& strong": {
                    lineHeight: "56px",
                    fontWeight: "700",
                },
            },
            "& h3": {
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "32px",
                fontWeight: "bold",
                lineHeight: "36px",
            },
            "& h4": {
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "24px",
                fontWeight: "bold",
                lineHeight: "30px",
            },
            "& h5": {
                marginTop: "10px",
                marginBottom: "10px",
                fontSize: "18px",
                fontWeight: "bold",
                lineHeight: "24px",
            },
            "& a": {
                color: "#ea5b1c",
                textDecoration: "none",
            },
        }}>
        <Grid.Item>
          <Meta title="UPT GENEL ÖDEME HİZMETLERİ SÖZLEŞMESİ (KURUMSAL MÜŞTERİ)"/>
          <Typography variant="h2">
            <strong>UPT GENEL ÖDEME HİZMETLERİ SÖZLEŞMESİ (KURUMSAL MÜŞTERİ)</strong>
          </Typography>
          <br />

          <Typography variant="h2">
            UPT ÖDEME HİZMETLERİ ve ELEKTRONİK PARA A.Ş. KİŞİSEL VERİLERİN KORUNMASI KANUNU HAKKINDA
            AYDINLATMA METNİ
          </Typography>
          <br />

          <Typography>
            7 Nisan 2016 tarihli ve 29677 Sayılı Resmî Gazete’de yayımlanan 6698 sayılı Kişisel
            Verilerin Korunması Kanunu (“Kanun”) hakkında, veri sorumlusu sıfatıyla UPT Ödeme
            Hizmetleri ve Elektronik Para A.Ş. (Şirket) olarak tüzel kişiliğinize ait ortaklarınızı,
            temsile yetkili kişilerinizi veya çalışanlarınızı bilgilendirmek isteriz.
          </Typography>
          <Typography>
            Kişisel Verilerin İşlenme Amaçları ve Hukuki Sebepleri: Şirketimiz; tüzel kişiliğiniz
            ile aramızdaki sözleşmenin ifası kapsamında ortaklarınıza, temsile yetkili kişilerinize
            veya çalışanlarınıza ait kişisel verilerinizi, işlem sahibinin bilgilerinin tespiti için
            kimlik ve diğer gerekli bilgilerinin kaydedilmesi; elektronik kanallar veya kağıt
            ortamında işleme dayanak olacak tüm kayıt ve belgelerin düzenlenmesi; mevzuat ve diğer
            otoritelerce öngörülen bilgi saklama, raporlama, bilgilendirme yükümlülüklerine uyum
            sağlanması; mevzuat hükümlerinin bilgi paylaşımına izin verdiği/bilgi paylaşımını
            zorunlu kıldığı kişi veya kuruluşlar ile bilgi paylaşımında bulunulabilmesi; planlama,
            istatistik, müşteri memnuniyeti ve hizmet kalitesinin artırılmasına yönelik çalışmalar,
            güvenliğin sağlanması, kara paranın aklamasının önlenmesi mevzuatına ve yurt içi ve
            uluslararası düzenlemelere uyum, şirketimizin ürün ve hizmetleri ile ilgili limit,
            istihbarat, bilgi araştırmaları ve değerlendirmelerin yapılabilmesi; şirketimizin ürün
            ve hizmetlerine ilişkin tarafınıza bilgi verilebilmesi, tarafınıza uygun pazarlama ve
            kampanya hizmetleri ile ürünler geliştirilmesi, bu kapsamda tarafınızla iletişime
            geçilmesi ve şirketimiz ile gerçekleştirdiğiniz işlemlere ilişkin şirketimizin
            tarafınıza karşı tüm yükümlülüklerinin yerine getirilmesi amacı ile işlemekte ve yetkili
            kurumlara aktarmaktadır.
          </Typography>
          <Typography>
            Tüzel kişiliğinizin Şirketimiz nezdindeki her türlü işlemleri ve bunlarla sınırlı
            olmaksızın ihtiyaç duyulan ya da duyulacak ortaklarınıza, temsile yetkili kişilerinize
            veya çalışanlarınıza ait kişisel veriler, işlenmesine muvafakat etmeniz durumunda,
            şirketimiz mevzuat hükümlerinin/tarafınızın bilgi paylaşımına izin
            verdiği(niz)/mevzuatın bilgi paylaşımını zorunlu kıldığı kişi veya kuruluşlar ile
            paylaşabilecektir.
          </Typography>
          <Typography sx={{ mb: "0 !important" }}>
            Yukarıda Belirtilen Amaçlarla, Kişisel Verilerin Aktarılabileceği Kişi/Kuruluşlar:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Mevzuat hükümlerinin bilgi paylaşımına izin verdiği/bilgi paylaşımını zorunlu kıldığı
              kişi veya kuruluşlar;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Bunlarla sınırlı olmamak üzere 3. kişiler; BDDK, TCMB, MASAK gibi kamu tüzel kişileri;
              resmî kurumlar,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ana hissedarımız, doğrudan ve dolaylı iştiraklerimiz, ana hissedarımızın iştirakleri,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Faaliyetlerimizi yürütmek üzere hizmet aldığımız, işbirliği yaptığımız, program ortağı
              kuruluşları, yurt içi/yurt dışı bankalar, yurt içi/yurt dışı para transferine aracılık
              eden kurumlar, destek hizmeti kuruluşları ve diğer 3. kişilerdir.
            </ListItem>
          </List>
          <Typography>
            <strong>Rıza Gerektirmeyen Haller: </strong>Kanun’un 5. maddesi uyarınca, kanunlarda
            açıkça öngörülmesi, bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili
            olması kaydıyla sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli
            olması, veri sorumlusu sıfatıyla şirketimizin hukuki yükümlülüğünü yerine getirebilmesi
            için zorunlu olması, ilgili kişi tarafından alenileştirilmiş olması, bir hakkın tesisi,
            kullanılması veya korunması için veri işlemenin zorunlu olması, ilgili kişinin temel hak
            ve özgürlüklerine zarar vermemek kaydıyla veri sorumlusu olan şirketimizin meşru
            menfaatleri için veri işlenmesinin zorunlu olması hallerinde açık rıza almaksızın
            kişisel verileri işleyebilme hakkı mevcuttur.
          </Typography>
          <Typography>
            <strong>Kişisel Verilerin Toplanma Yöntemi:</strong> Genel müdürlük, şubeler,
            temsilcilik yetkisi verilen kurum/kuruluşlar, kiosklar, internet sayfası, doğrudan ve
            dolaylı iştiraklerimiz, ana hissedarımız, şirketimizin hizmet aldığı kurum/kuruluşlar ve
            çağrı merkezi gibi kanallar aracılığıyla ortaklarınıza, temsile yetkili kişilerinize
            veya çalışanlarınıza ait kişisel veriler sözlü, yazılı veya elektronik ortamda
            toplanabilmektedir.
          </Typography>
          <Typography>
            <strong>Haklarınız: </strong>11.maddesi gereği; ortaklarınız, temsile yetkili
            kişileriniz veya çalışanlarınız, Şirketimize başvurarak, kişisel verilerinin; a) işlenip
            işlenmediğini öğrenme, b) işlenmişse bilgi talep etme, c) işlenme amacını ve bunların
            amacına uygun kullanılıp kullanılmadığını öğrenme, d) yurt içinde/yurt dışında
            aktarıldığı 3. kişileri bilme, e) eksik veya yanlış işlenmiş olması halinde
            düzeltilmesini isteme, f) Kanun’un 7. maddesinde öngörülen şartlar çerçevesinde
            silinmesini veya yok edilmesini isteme, g) aktarıldığı 3. kişilere yukarıda sayılan (e)
            ve (f) bentleri uyarınca yapılan işlemlerin bildirilmesini isteme, h) münhasıran
            otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya çıkmasına
            itiraz etme, i) kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde
            zararın giderilmesini talep etme hakkına sahiplerdir. Ortaklarınız, temsile yetkili
            kişileriniz veya çalışanlarınızın, taleplerinin yerine getirilmesini teminen
            Şirketimizce yapılacak masraflar, Kanun’un “Veri sorumlusuna başvuru” başlıklı 13.
            maddesinde belirtilen tarifeye göre tarafınızdan talep edilebilecektir.
          </Typography>
          <br />
          <Typography variant="h2">
            UPT GENEL ÖDEME HİZMETLERİ SÖZLEŞMESİ (KURUMSAL MÜŞTERİ)
          </Typography>
          <br />

          <Typography variant="h3">1. Tanımlar ve Yorumlama</Typography>
          <Typography variant="h4">
            <strong>1.1. Tanımlar</strong>
          </Typography>
          <Typography>
            İşbu UPT Genel Ödeme Hizmetleri Sözleşmesi (“GÖHS”) kapsamında kullanılan terimler
            aşağıdaki anlamlara sahip olacaktır:
          </Typography>
          <Typography variant="h5">Sözleşme</Typography>
          <Typography>
            Tüzel kişi müşterilere ilişkin olarak GÖHS kapsamında atıfta bulunulan, Web
            sitelerindeki bilgiler de dahil olmak, ancak bunlarla sınırlı kalmamak üzere, tüzel
            müşterilere ilişkin GÖHS'yi ve mevcut olması halinde diğer Koşulları ve belgeleri
            (ilaveler, sözleşmeler, kurallar, beyanlar, vb.) içeren, ödeme hizmetlerinin sunulmasına
            ilişkin olarak Müşteri ile UPT arasında akdedilen herhangi bir sözleşme.
          </Typography>
          <Typography variant="h5">Hesap</Typography>
          <Typography>
            UPT nezdinde, Müşteri adına sahip olunan ve Ödeme İşlemlerinin gerçekleştirilmesi için
            kullanılan herhangi bir ödeme hesabı.
          </Typography>
          <Typography variant="h5">Kullanılabilir Bakiye</Typography>
          <Typography>
            Müşterinin, muhtemel itiraz kayıtları, bloke edilen tutarlar göz önünde bulundurularak
            serbest bir şekilde kullanabileceği, ödeme hesabındaki tutar.
          </Typography>
          <Typography variant="h5">Bakiye</Typography>
          <Typography>
            Herhangi bir zamanda ödeme hesabında bulunan tutar. Bu bakiye, 7/24/365 esasına dayalı
            olarak o an için hesapta bulunan tutarı göstermektedir.
          </Typography>
          <Typography variant="h5">Lehtar</Typography>
          <Typography>
            Herhangi bir Ödeme İşleminin ait olduğu tutarların alıcısı olan şahıs.
          </Typography>
          <Typography variant="h5">Kayıt Tarihi</Typography>
          <Typography>
            Herhangi bir Ödeme İşleminin ve bunun sonucunda Bakiyede ortaya çıkan değişikliğin ödeme
            hesabında işleme koyulduğu tarih.
          </Typography>
          <Typography variant="h5">İş Günü</Typography>
          <Typography>
            Cumartesi, Pazar ve Türkiye'deki resmi tatil günleri hariç olmak üzere, herhangi bir
            gün.
          </Typography>
          <Typography variant="h5">Kanal</Typography>
          <Typography>
            UPT tarafından müşterilerin kullanımına sunulan mobil uygulama, internet sitesi, web
            servis veya diğer dijital kanallar aracılığıyla sağlanan güvenli online sistemi.
          </Typography>
          <Typography variant="h5">Müşteri</Typography>
          <Typography>
            UPT sisteminde kayıtlı olan, bir profil oluşturmuş olan ve herhangi bir ödeme hesabı
            olan tüzel kişiler veya tüzel kişiliği bulunmayan yönetim veya ortaklıklar veya Gerçek
            Kişilerin Ticari işletmeleri.
          </Typography>
          <Typography variant="h5">Müşteri Temsilcisi/Yetkilisi</Typography>
          <Typography>
            Müşterinin tüzel kişiliğini, yasal ve/veya faaliyet belgeleriyle (imza sirküsü, imza
            beyannamesi vb.) temsil ve ilzama yetkili olan kişi veya kişiler.
          </Typography>
          <Typography variant="h5">Müşteri Tanımlama</Typography>
          <Typography>
            Sistemde öngörülen süreç kapsamında, UPT'nin müşterisi olmayı amaçlayan gerçek veya
            tüzel kişiliğin tespiti.
          </Typography>
          <Typography variant="h5">Komisyon Ücreti</Typography>
          <Typography>
            UPT tarafından herhangi bir Ödeme İşlemi ve (veya) ilgili hizmetler için alınan ücret.
          </Typography>
          <Typography variant="h5">Koşullar</Typography>
          <Typography>
            İşbu GÖHS kapsamında yer alan Ödeme Hizmetlerine ilişkin UPT Koşulları.
          </Typography>
          <Typography variant="h5">Alacak Transferi</Typography>
          <Typography>
            UPT'nin müşterisi olan ödeme yapanın/borçlunun inisiyatifinde, tutarların, Hesaptan,
            ödeme alanın/alacaklının herhangi bir ödeme hesabına aktarıldığı Ödeme İşlemi.
          </Typography>
          <Typography variant="h5">Kapanış Zamanı</Typography>
          <Typography>
            UPT tarafından, aynı İş Gününde ilgili talimatın gerçekleştirilmesinin başlatılabilmesi
            amacıyla herhangi bir Ödeme Emrinin, Ödeme İşleminin veya diğer talimatın veya
            iletişimin UPT tarafından tesellüm edilmesi gereken İş Günü içerisindeki herhangi bir
            zaman.
          </Typography>
          <Typography variant="h5">
            Ödeme Hesabı
            <Typography sx={{ display: "inline-block" }}>
              (ayrıca işbu GÖHS kapsamında tutarlar olarak da anılmaktadır)
            </Typography>
          </Typography>
          <Typography>
            UPT nezdinde, müşteri adına açılan ve ödeme hizmetlerinin sunulması amacıyla kullanılan,
            müşteriye ait fonların izlendiği ve yönetildiği hesaptır. Ödeme hesabında yer alan
            tutarlar, 6493 sayılı kanun kapsamında elektronik para niteliği taşımamakta olup,
            yalnızca ödeme işlemlerinin gerçekleştirilmesi amacıyla kullanılmaktadır.
          </Typography>
          <Typography variant="h5">Dolandırıcılık</Typography>
          <Typography>
            Başlatılması Müşterinin manipülasyonunu içeren Yetkisiz Ödeme İşlemleri. Yetkisiz Ödeme
            İşlemleri, Kişiselleştirilmiş Güvenlik Özelliklerinin kaybolması, çalınması veya kötüye
            kullanılması ya da diğer hassas ödeme verilerinin kaybedilmesi sonucu ortaya
            çıkabilecektir.
          </Typography>
          <Typography variant="h5">GÖHS</Typography>
          <Typography>İşbu UPT Genel Ödeme Hizmetleri Sözleşmesi.</Typography>
          <Typography variant="h5">
            <strong>Taraflar</strong>
          </Typography>
          <Typography>Müşteri ile UPT.</Typography>
          <Typography variant="h5">
            <strong>Ödeme İşlemi</strong>
          </Typography>
          <Typography>
            Ödeme yapan/borçlu tarafından veya ödeme yapan/borçlu namına ve hesabına ya da ödeme
            alan/alacaklı tarafından başlatılan, ödeme yapan/borçlu ile ödeme alan/alacaklı
            arasındaki dayanak yükümlülüklere bakılmaksızın, tutarların yatırılmasına, transfer
            edilmesine veya çekilmesine ilişkin herhangi bir işlem.
          </Typography>
          <Typography variant="h5">Ödeme Aracı</Typography>
          <Typography>
            UPT ile Müşteri arasında kararlaştırılan ve Ödeme Emrini başlatmak için kullanılan
            kişiselleştirilmiş cihaz(lar).
          </Typography>
          <Typography variant="h5">Ödeme Emri</Typography>
          <Typography>
            Ödeme İşleminin gerçekleştirilmesinin talep edildiği, Müşteri tarafından UPT'ye verilen
            ödeme talimatı.
          </Typography>
          <Typography variant="h5">Ödeme Hizmetleri</Typography>
          <Typography sx={{ mb: "0 !important " }}>
            Sözleşme kapsamında UPT tarafından Müşteriye sunulan ödeme hizmetleri aşağıdakileri
            içermektedir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Müşteri adına hesaba özel bir IBAN ile ödeme hesabı açılması,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme hesabına ilişkin işlemlerin gerçekleştirilmesi,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme emirlerinin alınması, iletilmesi ve gerçekleştirilmesi,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme işlemlerine ilişkin olarak gerekli görülen bilgilendirme ve işlem kayıtlarının
              tutulması,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme işlemlerinin mobil uygulama, internet sitesi, web servis veya diğer dijital
              kanallar aracılığıyla gerçekleştirilmesi
            </ListItem>
          </List>

          <Typography variant="h5">Kişiselleştirilmiş Güvenlik Özellikleri</Typography>
          <Typography>
            Müşterinin kimliğini doğrulamak üzere kullanılan ve aşağıdaki özellikleri içeren gizli
            bilgiler: Müşteriye SMS yoluyla gönderilen tek seferlik kişiselleştirilmiş kod, Hesaba
            erişmek ve/veya Ödeme Emirlerine izin vermek amacıyla Müşteri tarafından oluşturulan
            uzun süreli şifre ve kullanıcı kimliği. UPT ödeme platformunda oturum açmak amacıyla,
            Müşteri tarafından kullanıcı kimliğinin, şifrenin ve SMS yoluyla gönderilen tek seferlik
            şifrenin girilmesi gerekecektir. UPT, düzenlenecek Kişiselleştirilmiş Güvenlik
            Özelliklerinin türüne karar verme hakkına sahip olacak ve gerekli görülmesi halinde bunu
            dilediği zaman değiştirebilecektir.
          </Typography>
          <Typography>
            Uluslararası Ödeme Transferi Sistemi ile ödeme işlemi gerçekleştirmek ve/veya izin
            vermek, ödeme hesabına erişmek için Müşteri’nin e-posta adresine iletilen kullanıcı
            kimliği ve Müşteri tarafından oluşturulan uzun süreli şifre. Uluslararası Ödeme
            Transferi Sistemi’nde oturum açmak amacıyla, e-posta adresine iletilen kullanıcı kimliği
            ile Müşteri tarafından uzun süreli şifrenin oluşturulması gerecektir. UPT, düzenlenecek
            Kişiselleştirilmiş Güvenlik Özelliklerinin türüne karar verme hakkına sahip olacak ve
            gerekli görülmesi halinde bunu dilediği zaman değiştirebilecektir.
          </Typography>
          <Typography variant="h5">Profil</Typography>
          <Typography>
            Müşterinin, UPT nezdinde tanımlanarak ödeme hizmetlerinden yararlanabilmesi amacıyla
            oluşturulan ve müşteri bilgilerini içeren dijital kaydı ifade eder.
          </Typography>
          <Typography variant="h5">Ekstre (veya Hesap Özeti)</Typography>
          <Typography>
            Müşterinin ödeme hesabına ilişkin olarak gerçekleştirilen işlemleri, hesap hareketlerini
            ve bakiye bilgilerini gösteren, UPT tarafından sunulan bilgilendirme dokümanıdır.
          </Typography>
          <Typography variant="h5">Sistem</Typography>
          <Typography>
            UPT'nin, kullanılabilir olan, Müşteri tarafından Web Sitesi veya UPT mobil uygulaması
            aracılığıyla ulaşılabilen ve Ödeme İşlemlerinin başlatılması, ödeme hesabı bakiyesinin
            kontrol edilmesi, gerçekleştirilen Ödeme İşlemleri ve Hesap ile ilgili diğer bilgiler
            için Müşteri tarafından kullanılacak olan online ödeme platformu.
          </Typography>
          <Typography variant="h5">Tarifeler</Typography>
          <Typography>
            Tarifeler ve Koşullar kapsamında belirtilen Ödeme Hizmetlerine ilişkin tüm fiyatlar,
            ücretler, komisyonlar, masraflar ve bedeller.
          </Typography>
          <Typography variant="h5">Tarifeler ve Koşullar</Typography>
          <Typography>
            Ödeme Hizmetlerine ilişkin olarak UPT'nin tarifelerinin ve ilave koşullarının
            belirlendiği belge(ler).
          </Typography>
          <Typography variant="h5">Özgün Tanımlayıcı</Typography>
          <Typography>
            UPT tarafından Müşteriye tayin edilen ve Müşterinin veya Hesabının tanımlanabileceği
            harf, sayı veya sembol kombinasyonu. Örneğin; Hesabın IBAN numarası.
          </Typography>
          <Typography variant="h5">UPT</Typography>
          <Typography>
            Türkiye Cumhuriyeti kanunları çerçevesinde kurulu bulunan ve mevcudiyetini sürdüren,
            8930282990 vergi numaralı ve ticari merkezi Esentepe Mah. Kore Şehitleri Cad. No:8/1
            Şişli/İstanbul adresinde bulunan bir anonim şirket olan UPT Elektronik Para ve Ödeme
            Hizmetleri A.Ş.
          </Typography>
          <Typography variant="h5">Uluslararası Ödeme Transferi Sistemi</Typography>
          <Typography>
            UPT'nin Müşteriye, UPT tarafından Üyeleri ve Ortakları vasıtasıyla Türkiye'ye ve diğer
            ülkelere ve Türkiye'den ve diğer ülkelerden gelen ve giden ödemeleri işleme tabi tuttuğu
            web servis tabanlı para transferi sisteminin tescilli ticari markasıdır.
          </Typography>
          <Typography variant="h5">Valör</Typography>
          <Typography>
            (Mevcut ise) faiz hesaplaması ile ilgili olarak Ödeme İşleminin göz önünde
            bulundurulduğu tarih.
          </Typography>
          <Typography variant="h5">Virüs</Typography>
          <Typography>
            Herhangi bir yetkisiz şahsın herhangi bir bilgisayar sistemine erişim sağlaması veya söz
            konusu sistemi kullanmasına izin verilmesi, söz konusu sistemin işe yaramaz, hasarlı
            veya bozulmuş hale getirilmesi veya normal kullanımının aksatılması veya bozulması
            amacıyla tasarlanan herhangi bir virüs veya herhangi bir diğer yazılım rutini.
          </Typography>
          <Typography variant="h5">Web Sitesi</Typography>
          <Typography>
            <a href="http://www.upt.com.tr/">www.upt.com.tr</a> ,
          </Typography>
          <Typography>
            <a href="http://www.uption.com.tr/">www.uption.com.tr</a>
          </Typography>

          <Typography variant="h3">1.2. Yorumlama</Typography>
          <Typography>
            <strong>1.2.1. </strong>Bağlam açık bir şekilde aksini gerektirmediği sürece, Sözleşmeye
            yapılan atıflar, Sözleşmenin herhangi bir ekine yapılan atıflar olarak yorumlanacak
            olup, Sözleşmenin herhangi bir hükmüne yapılan atıflar ise, söz konusu Sözleşmenin
            herhangi bir hükmüne yapılan atıflar olarak yorumlanacaktır.
          </Typography>
          <Typography>
            <strong>1.2.2. </strong>Sözleşmede yer alan başlıklar yalnızca başvuru kolaylığı sağlama
            amaçlıdır.
          </Typography>
          <Typography>
            <strong>1.2.3. </strong>Aksine ifade olmadığı sürece, Sözleşme kapsamında aşağıdaki
            terimlere yapılan atıflar aşağıdaki şekilde yorumlanacaktır:
          </Typography>
          <Typography>
            “Şahıs” terimi herhangi bir gerçek veya tüzel kişiyi kapsamaktadır;
          </Typography>
          <Typography>
            “Müşteri” terimi müşteriyi temsile yetkili olan “müşteri temsilcisi/yetkilisi”
            kapsamaktadır; "içerir/kapsar", "dahil" ve "dahil olmak üzere" terimlerinin "herhangi
            bir sınırlama olmaksızın" ibaresi ile birlikte kullanılacağı addedilecektir.
          </Typography>
          <Typography>
            Herhangi bir sözleşme, Koşullar, şartlar, kural kitabı veya belge, zaman zaman tadil
            edilen, ilaveler yapılan veya yeniden kabul edilen söz konusu sözleşmeye, Koşullara,
            şartlara, kural kitabına veya belgeye yapılan atfı teşkil etmektedir.
          </Typography>

          <Typography variant="h3">2. Genel Koşullar</Typography>
          <Typography variant="h4">
            <strong>2.1. Sözleşme Dili</strong>
          </Typography>
          <Typography>
            Müşteri ile UPT, bu vesileyle, Sözleşmenin Web Sitesinde yer aldığı üzere Türkçe
            dillerinde hazırlandığını kabul etmektedirler.
          </Typography>
          <Typography variant="h4">2.2. Konu</Typography>
          <Typography>
            <strong>2.2.1. </strong>GÖHS kapsamında, Müşteri ile UPT arasında kararlaştırılan ve UPT
            tarafından sunulan tüm Ödeme Hizmetleri için geçerli olan genel şartlar ve koşullar
            ortaya konmaktadır.
          </Typography>
          <Typography>
            <strong>2.2.2. </strong>GÖHS, Müşterinin Sisteme kaydolması, GÖHS hakkında bilgi sahibi
            olması, GÖHS'ye riayet edeceğine muvafakat etmesi ve Müşteri Tanımlama süreçlerinin,
            Müşteri ile çalışılmaya başlanmasına ilişkin olarak olumlu yönde sonuçlanarak
            tamamlanması sonrasında yürürlüğe girecek ve süresiz olarak geçerli olacaktır.
          </Typography>
          <Typography>
            <strong>2.2.3. </strong>GÖHS’nin Müşteri tarafından imzalanmış olması, UPT’ye Sözleşme
            kapsamında düzenlenen herhangi bir ürünü veya hizmeti sunma yükümlülüğü altına sokmaz.
            Müşteri, UPT’nin, herhangi bir gerekçe göstermeksizin ürünlerin bir kısmını ya da
            tamamını kullandırıp kullandırmama, Hesapları tasfiye ve GÖHS’yi sonlandırma hakkına
            sahip olduğunu ve Hesapların, yasadışı bahis ve şans oyunlarıyla bağlantılı olarak para
            nakline aracılıkta kullanılması veya bu yönde bir şüphe oluşması başta olmak üzere,
            hileli ve yetkisiz kullanım şüphesi doğması halinde UPT’nin ilgili Hesabı kapatma
            hakkına sahip olduğunu kabul ve taahhüt eder. UPT, kullanıma kapatma gerekçesi konusunda
            Müşteri’yi bilgilendirir.
          </Typography>
          <Typography>
            <strong>2.2.4. </strong>Müşteri, GÖHS (tadilleri de dahil olmak üzere) ve tüm belgeler
            ile bilgilerin, Müşteriye, e-posta veya kabul edilebilir diğer elektronik yöntemler
            vasıtasıyla temin edilebileceğini ikrar ve kabul etmektedir.
          </Typography>
          <Typography>
            <strong>2.2.5. </strong>GÖHS veya geçerli yasal gereklilikler arasında herhangi bir
            çelişki ve/veya tutarsızlık olması halinde, Ödeme Hizmetleri UPT tarafından geçerli
            yasal gerekliliklere uygun olarak sunulacaktır.
          </Typography>

          <Typography variant="h4">2.3. Kullanılabilirlik ve Tadiller</Typography>
          <Typography>
            <strong>2.3.1. </strong>Sözleşmenin en son versiyonu, Web Sitesinde mevcuttur. Talep
            edilmesi halinde, UPT tarafından Sözleşmenin nüshaları ücretsiz olarak temin
            edilecektir.
          </Typography>
          <Typography>
            <strong>2.3.2. </strong>UPT, Sözleşmeyi tadil etme ve/veya Sözleşmeye ilaveler yapma
            hakkına sahip olacaktır. Bununla birlikte, UPT, Müşteriyi, tadiller ve tadil edilmiş
            GÖHS'ye yapılan ilaveler ile ilgili olarak, söz konusu tadillerin ve/veya ilavelerin
            yürürlüğe girdiği tarihin en geç 30 (otuz) gün öncesinde ve Müşteri, GÖHS'yi feshetme
            olasılığı hakkında da bilgilendirerek bildirimde bulunacaktır; aksi takdirde tadil
            edilen hükümlerin Müşteri tarafından kabul edildiği addedilecektir. Söz konusu tadilin,
            mevzuatın zorunlu gereklilikleri ve/veya güvenlik veya uygunluk nedenleriyle resmi
            makamların gereklilikleri ile ilgili herhangi bir değişiklikten dolayı
            gerçekleştirilmesi halinde veya Müşterinin tercihine bağlı olarak Müşteri tarafından
            kullanılabilen veya kullanılamayan yeni Ödeme Hizmetinin uygulama konması halinde,
            UPT'nin, Müşteriyi, 30 (otuz) gün önceden bilgilendirmeme hakkı saklıdır.
          </Typography>
          <Typography>
            <strong>2.3.3. </strong>Müşteri, UPT'yi, en geç GÖHS'ye ilişkin tadillerin ve/veya
            ilavelerin yürürlüğe girdiği tarihte GÖHS'yi feshetme kararı ile ilgili olarak
            bilgilendirmediği sürece, GÖHS'ye ilişkin söz konusu tadilleri ve/veya ilaveleri kabul
            etmiş olarak addedilecektir. Böyle bir fesih herhangi bir bedele tabi değildir. UPT'nin
            GÖHS kapsamında Müşteri karşısındaki alacakları söz konusu tarihte derhal muaccel hale
            gelecektir.
          </Typography>

          <Typography variant="h4">
            <strong>2.4. </strong>Müşterinin İşbirliği, Bilgileri ve İletişim Bilgileri
          </Typography>
          <Typography>
            <strong>2.4.1. </strong>Müşteri, Ödeme Hizmetleri ile ilgili olarak, aşağıdaki
            hususların yerine getirilmesini sağlayacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Kara paranın aklanmasının önlenmesi, terörle mücadele, finansman ve yaptırım kanunları
              ve düzenlemeleri de dahil olmak, ancak bunlarla sınırlı kalmamak üzere, tüm geçerli
              kanunlara ve düzenlemelere riayet edilmesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Kara paranın aklanmasına yönelik uygulamalar ve terörizmin finansmanı ile mücadele
              edilmesi, şeffaf ve sağlam finansal piyasaların ve/veya (finansal) dolandırıcılığın
              önlenmesine yönelik diğer hususların sürdürülmesi amacıyla UPT'ye tam işbirliğinin
              sunulması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT ile işbirliği yapılması ve UPT'nin, Hesabın açılması ve işletilmesi ile Ödeme
              Hizmetlerinin sunulmasına ilişkin kanunlar, düzenlemeler veya UPT'nin iç politikaları
              kapsamında öngörülen bilcümle bilgilerin talep üzerine UPT'ye sunulması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT tarafından yerel ve yabancı otoritelerin (vergi otoritelerinin) taleplerine riayet
              edilmesine imkan verecek bilcümle bilgilerin sunulması ve bu tür fiil ve eylemlerde
              bulunulması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin kimliğinin kontrol edilmesi ve müşterini tanı düzenlemelerine riayet
              edilmesi için gerekli bilcümle bilgilerin UPT'ye sunulması.
            </ListItem>
          </List>
          <Typography>
            <strong>2.4.2. </strong>Müşteri, UPT'ye, UPT tarafından kullanılacak olan kendi iletişim
            bilgilerini sunacaktır. İletişim bilgilerinin, Müşterinin kusuru nedeniyle bilinmemesi
            veya artık bilinmez hale gelmesi halinde, UPT, bu hususta yükümlü olmaksızın, Müşterinin
            iletişim bilgilerini öğrenmeye çalışabilecektir. Böyle bir soruşturmaya ilişkin giderler
            Müşteriye ait olacaktır. Müşteri, adresinde meydana gelen değişiklikleri, söz konusu
            değişiklik tarihinden itibaren en geç 5 (beş) iş günü içerisinde UPT’ye bildireceğini
            aksi takdirde eski adresine yapılacak bildirimlerin geçerli olacağını gayrikabili rücu
            kabul, beyan ve taahhüt eder.
          </Typography>
          <Typography>
            <strong>2.4.3. </strong>Müşteri, Müşteri tarafından UPT'ye sunulan tüm bilgilere, UPT
            aksi yönde yazılı bildirim alıncaya değin UPT tarafından doğru, kesin ve eksiksiz olarak
            itimat edilebileceğini açık bir şekilde kabul ve ikrar etmektedir. Müşteri tarafından,
            sunulan bilgilere ilişkin herhangi bir değişiklik ve/veya güncelleme ile ilgili olarak
            UPT'ye en kısa süre içerisinde bildirimde bulunulacaktır.
          </Typography>
          <Typography>
            <strong>2.4.4. </strong>Müşteri, Sözleşme ’deki hizmetlerden yararlanmak için UPT’ye
            verdiği tüm bilgilerin doğru ve eksiksiz olduğunu beyan eder. Müşteri, bu bilgilerin
            doğruluğuna güvenerek işlem yapan UPT’nin, bilgilerin eksik, hatalı ya da yanlış
            olmasından kaynaklanan bir zararının oluşması halinde, bu zarardan sorumlu olacaktır.
          </Typography>
          <Typography variant="h4">2.5. Kayıt ve Hesap Açılışı</Typography>
          <Typography>
            <strong>2.5.1. </strong>UPT tarafından Müşteriye hizmetler, Müşterinin tüzel kişiliği
            temsile yetkili kişi/kişilerin GÖHS’yi imzalaması ve gerekli belgeleri UPT’ye ibraz
            ederek KYC (Müşterini Tanı) sürecinde geçmesi halinde sunulmaktadır. UPT, tamamen kendi
            takdir hakkı ve yetkisi doğrultusunda, UPT tarafından Müşterilere sunulan farklı Ödeme
            Hizmetlerine ve/veya ürünlere ilişkin olarak farklı gereklilikler belirleme hakkına
            sahip olacaktır.
          </Typography>
          <Typography>
            <strong>2.5.2. </strong>Ödeme Hizmetlerini kullanmaya başlayabilmek için, Müşteri
            tarafından öncelikle Web sitesine girilmeli ve bilgileri kaydedilerek, UPT (UPTION) Web
            sitesi aracılığıyla Tüzel Müşteri Kullanıcı oluşturma formu doldurulmalıdır. Doldurulan
            form UPT’ye ulaştırıldıktan sonra Kullanıcı Kod’ları Müşteri tarafından girişi yapılan
            e-posta ve cep telefonu bilgilerine gönderilecektir.
          </Typography>
          <Typography>
            <strong>2.5.3. </strong>Kayıt işlemi kapsamında, işbu GÖHS ile UPT Gizlilik Politikası
            ve Müşteri tarafından kullanılması amaçlanan Ödeme Hizmetlerinin kapsamı göz önünde
            bulundurularak Müşteriye iletilebilecek diğer belgelerin Müşteri tarafından kabul
            edilmesi gerekecektir.
          </Typography>
          <Typography>
            <strong>2.5.4. </strong>Sisteme kayıt olunduğunda, Müşteri için bir Profil
            oluşturulmaktadır. Söz konusu Profil müşteriye özel olup, sadece profilin sahibi olan
            Müşteri Profili kullanma hakkına sahiptir. Müşteriyi temsile yetkili olan her yetkili
            UPT'nin (UPTION) Web Sitesi aracılığıyla sisteme kaydolabilecektir. Müşteri sisteme
            giriş yapacak kullanıcıların, yönetici yetkisi, tam yetki, sınırlı yetki, görüntüleme ve
            yetkisiz olacak şekilde işlem yetkilerini ve işlem tutar limitlerini tanımlayabilecek
            olup dilediği zaman yetki ve limit tanımlarını değiştirebilecektir. Müşteri, Profile
            giriş yapma ve/veya Müşteri hesabına Ödeme İşlemlerini başlatma imkânı veren
            Kişiselleştirilmiş Güvenlik Özelliklerini herhangi bir üçüncü tarafa açıklamayacağını
            taahhüt etmektedir. Söz konusu taahhüdün yerine getirilememesi nedeniyle ortaya çıkan
            tüm sonuçlar Müşteriye aittir.
          </Typography>
          <Typography>
            <strong>2.5.5. </strong>Müşteri tarafından sadece tek bir Profile sahip olunacak ve
            Sistemde birden fazla Profil bulundurulması yasaklanacaktır.
          </Typography>
          <Typography>
            <strong>2.5.6. </strong>Hesap, Müşteri’yi temsile yetkili kişi tarafından açılabilecek
            olup Müşteri, söz konusu kişi/kişilerin temsili yetkili kişiler olduğunu kabul, beyan ve
            taahhüt eder. Müşteri, söz konusu yetkili kişi/kişilerin yetki ve sorumluluklarını
            gösterir imza sirkülerini UPT’ye vermekle yükümlüdür. Müşteri, söz konusu temsil ve
            ilzama yetkili kişilerde veya temsil yetkisinin kapsamında herhangi bir değişiklik
            olduğunda ilgili belgeyi derhal UPT’ye yazılı olarak iletmekle yükümlü olup aksi
            takdirde UPT’nin herhangi bir sorumluluğu olmayacağını kabul, beyan ve taahhüt eder.
          </Typography>
          <Typography>
            <strong>2.5.7. </strong>Müşteri, Sisteme kaydolurken ve Profili oluştururken doğru
            veriler sunacaktır. Müşteri tarafından doğru olmayan verilerin sunulması halinde,
            Müşteri bu verileri düzeltmekle yükümlüdür. Bu hükmün ihlal edilmesi halinde, Müşterinin
            Profili ve/veya işlemleri bloke edilebilecek ve yasal bir dayanağın belirlenmesi
            halinde, ilgili bilgiler, kolluk kuvvetlerine iletilebilecektir (iletilecektir).
          </Typography>
          <Typography>
            <strong>2.5.8. </strong>Müşteri, Sisteme kayıt olduğu sırada Müşteri tarafından
            belirtilen e-posta ve/veya SMS mesajı yoluyla kayıt işleminin tamamlandığının teyidi ile
            ilgili bir bildirim alacaktır.
          </Typography>
          <Typography>
            <strong>2.5.9. </strong>Müşteri tarafından Sisteme kaydolunması ve bir Profil
            oluşturulması sonrasında, ihtiyaç duyulması halinde, Müşteri tarafından birden fazla
            para birimi cinsinde Hesap açılabilecektir.
          </Typography>
          <Typography>
            <strong>2.5.10. </strong>Müşteri tarafından Profil ile bağlantılı en fazla 6 (altı)
            Hesap oluşturabilecek ve muhafaza edebilecek ve bu hesaplar Müşterinin kendi tasarrufu
            doğrultusunda kullanılabilecektir. Her bir para biriminde 2 (iki) adet Hesap
            açılabilecektir.
          </Typography>
          <Typography>
            <strong>2.5.11. </strong>Müşteri, açtığı hesaplarını alacaklandırabilecek, diğer bir
            deyişle herhangi bir banka ve/veya ödeme kuruluşu üzerinden para transferi ile ödeme
            alabilecek, ancak hesaplarını borçlandırabilmesi bir diğer deyişle herhangi bir
            hesabından ödeme yapabilmesi için kendisine kurye aracılığı ile yönlendirilmiş olan
            GÖHS’yi ıslak imza ile imzalaması, UPT’ye teslimi ve sözleşme onayı beklenecektir.
          </Typography>
          <Typography>
            <strong>2.5.12. </strong>Kurye ile sözleşme gönderim süreci müşterinin herhangi bir
            hesabının alacaklandırılması ile başlatılacaktır.
          </Typography>
          <Typography>
            <strong>2.5.13. </strong>Sözleşmenin UPT’ye teslimi ve sözleşme onayı ardından
            hesaplardaki bloke otomatik olarak kaldırılacak, Müşterinin halihazırda açılmış olan tüm
            hesapları aktif hale getirilecektir.
          </Typography>

          <Typography variant="h4">3. Ödeme Hizmetleri ve Hesap</Typography>
          <Typography variant="h4">
            <strong>3.1. Ödeme Hizmetlerinin Amacı</strong>
          </Typography>
          <Typography>
            <strong>3.1.1. </strong>Ödeme Hizmetleri Müşteri tarafından sadece Müşterinin Profilinin
            oluşturulması tamamlandıktan sonra kullanılabilir.
          </Typography>
          <Typography>
            <strong>3.1.2. </strong>Müşteri, Hesabı sadece ticari ihtiyaçlar için kullanma hakkına
            sahip olacaktır. Müşteri tarafından UPT'nin Ödeme Hizmetlerinin Müşteri yetkilisinin
            kişisel amaçları için kullanılmaya başlanmak istenmesi halinde, Müşteri tarafından, UPT
            tarafından belirlenecek farklı şartlara ve koşullara tabi olan bireysel Hesap
            açılmalıdır. Bunun yapılmaması, GÖHS'nin derhal geçerli olmak üzere tek taraflı olarak
            feshine tabi olacaktır.
          </Typography>
          <Typography>
            <strong>3.1.3. </strong>Ödeme Hizmetleri Müşteri tarafından, kara paranın aklanması
            ve/veya terörizmin finansmanı, dolandırıcılık amaçlı olması da dahil olmak üzere,
            herhangi bir düzenlemenin ihlali niteliğinde olan veya UPT'nin itibarı üzerinde veya
            finansal sistemin bütünlüğü üzerinde zararlı etkiye sahip olabilecek olan faaliyetler
            veya amaçlar için kullanılmayacaktır.
          </Typography>
          <Typography>
            <strong>3.1.4. </strong>Müşteri, UPT’nin herhangi bir gerekçe göstermeksizin, ürünlerin
            bir kısmını ya da tamamını kullandırıp kullandırmama, hesapları tasfiye etme ya da
            Sözleşmeyi sonlandırma hakkına sahip olduğunu, hesapların yasadışı bahis ve şans
            oyunlarıyla bağlantılı olarak para nakline aracılıkta kullanılması veya bu yönde bir
            şüphe oluşması halinde UPT’nin Hesap, Ürün ve Hizmetleri herhangi bir ihbara gerek
            kalmaksızın kapatma hakkına sahip olduğunu kabul ve taahhüt eder.
          </Typography>
          <Typography>
            <strong>3.1.5. </strong>Müşteri tarafından, talep edilmesi halinde faaliyetleri ve
            hedefleri ile ilgili resmî açıklamalar ve beyanlar da dahil olmak üzere, Ödeme
            Hizmetlerinin (amaçlanan) kullanım nedenleri ve UPT nezdinde yatırılan veya yatırılacak
            olan tutarların kaynağı hakkında UPT'nin ilk talebi üzerine UPT'ye bilgi verilecektir.
          </Typography>
          <Typography>
            <strong>3.1.6. </strong>Müşteri tarafından Ödeme Hizmetinin, Uluslararası Ödeme
            Transferi Sistemi ile alınması durumunda söz konusu hizmeti müşteri UPT’nin yazılı onayı
            olmadan üçüncü kişiler için kullandıramaz. UPT’nin yazılı onayı olmadan kullandırım
            halinde, UPT GÖHS’nin derhal geçerli olmak üzere tek taraflı fesih hakkına sahip
            olacaktır.
          </Typography>

          <Typography variant="h4">3.2. Hesap</Typography>
          <Typography>
            <strong>3.2.1. </strong>Hesapta tutulan tutarlar, ödeme hizmetlerinin sunulması amacıyla
            kullanılan ödeme hesabı bakiyesi niteliğindedir. Bu tutarlar mevduat teşkil etmemektedir
            ve UPT tarafından bu paranın tutulması sebebiyle faiz ödenmeyecektir.
          </Typography>
          <Typography>
            <strong>3.2.2. </strong>Müşteri, ödeme hesabına ilişkin tüm işlem ve talimatların,
            yalnızca kendisi veya yetkilendirdiği kişiler tarafından verilmesini sağlamakla
            yükümlüdür. Müşteri, ödeme hesabına ilişkin kullanıcı adı, şifre, tek kullanımlık
            doğrulama kodu ve benzeri güvenlik bilgilerinin gizliliğini korumakla sorumludur. Bu
            bilgilerin üçüncü kişilerle paylaşılması veya güvenliğinin ihlal edilmesi sonucu meydana
            gelen işlemlerden UPT sorumlu tutulamaz.
          </Typography>
          <Typography>
            <strong>3.2.3. </strong>Hesap, Müşterinin, transfer amacıyla, tutarları Hesaba
            yatırmasına, Hesaba/Hesaptan transferler gerçekleştirmesine, tutarları Hesapta
            tutmasına, yerel ve uluslararası para transferlerini yapmasına, Hesaba para almasına ve
            para transferleriyle doğrudan ilgili diğer işlemleri gerçekleştirmesine imkân veren bir
            ödeme hesabıdır.
          </Typography>
          <Typography>
            <strong>3.2.4. </strong>Hesap, Müşteri yetkilisi tarafından kullanıcı kimliği, uzun
            süreli şifre ve Müşteriye SMS yoluyla gönderilen tek seferlik şifre ile Profile giriş
            yapılarak yönetilebilir.
          </Typography>
          <Typography>
            <strong>3.2.5. </strong>Müşteri tarafından Profile giriş yapılmaması ve Hesapta bir
            yıldan uzun bir sürede herhangi bir işlem gerçekleştirilmemesi halinde, UPT tarafından
            Profilin ve Hesabın (Hesapların) kullanımda olmadığı (hareketsiz olduğu) addedilecektir.
            UPT, Profillerin ve Hesapların kullanımda olmaması ve Hesaplarda hiçbir tutarın mevcut
            olmaması koşuluyla, Müşteriye, hareketsiz Profiller ve Hesaplar ile ilgili olarak
            fesihin 60 gün öncesinde bildirimde bulunmak suretiyle, GÖHS'yi ve Müşteri ile akdi
            ilişkileri feshetme ve Profili ve Hesabı (Hesapları) kapatma hakkına sahiptir. En az bir
            hareketsiz Hesapta tutar olması halinde, UPT tarafından Profil açık bırakacak ve sadece
            hareketsiz Hesap (Hesaplar) kapatılacaktır. Müşterinin Profilinin ve tutar içeren
            Hesabın (Hesapların) iki yıl boyunca hareketsiz kalması halinde, UPT tarafından
            hareketsiz Profil ve tutar içeren Hesapların işletilmesi için burada yer almakta olan
            Komisyon Ücretinin uygulanmasına başlanacaktır.
          </Typography>

          <Typography variant="h4">3.3. Elektronik Para İhracı ve İtfa Şartları</Typography>
          <Typography>
            <strong>3.3.1. </strong>Hesapta tutulan tutarlar, Müşteri tarafından UPT nezdinde
            gerçekleştirilen ödeme işlemleri kapsamında kullanılan fonları ifade eder. Bu tutarlar,
            ödeme hizmetlerinin sunulması amacıyla UPT tarafından muhafaza edilir ve elektronik para
            niteliği taşımaz. Müşteri, söz konusu tutarlar üzerinde yalnızca ödeme hizmetlerinden
            yararlanma hakkına sahiptir; bu tutarlar üzerinden faiz, getiri ve benzeri bir hak
            talebinde bulunamaz.
          </Typography>
          <Typography>
            <strong>3.3.2. </strong>UPT, ödeme fonlarının korunmasına yönelik olarak mevzuatın
            öngördüğü tedbirleri almakla yükümlü olup, bu tutarların yönetimi sırasında mevzuata
            uygun hareket eder.
          </Typography>
          <Typography>
            <strong>3.3.3. </strong>Müşteri, ödeme hesabına ilişkin tüm işlemlerin kendi talimatı
            doğrultusunda gerçekleştirildiğini ve bu işlemlerden doğan sonuçlardan bizzat sorumlu
            olduğunu kabul eder. Müşteri, ödeme hesabının kullanımına ilişkin olarak gerekli dikkat
            ve özeni göstermekle yükümlü olup, yetkisiz kullanım, hatalı işlem veya üçüncü kişilerce
            gerçekleştirilen işlemler nedeniyle doğabilecek zararlardan UPT sorumlu tutulamaz.
          </Typography>
          <Typography>
            <strong>3.3.4. </strong>Müşteri, ödeme hesabının güvenliği sağlamak amacıyla kendisine
            tahsis edilen kullanıcı bilgilerini, şifreleri, doğrulama kodlarını ve benzeri güvenlik
            unsurlarını gizli tutmakla yükümlüdür. Bu bilgilerin üçüncü kişilerce paylaşılması veya
            gerekli özenin gösterilmemesi nedeniyle doğabilecek zararlardan UPT sorumlu tutulamaz.
          </Typography>
          <Typography>
            <strong>3.3.5. </strong>UPT, ödeme hesabına ilişkin işlemlerin güvenliğini sağlamak
            amacıyla gerekli teknik ve idari tedbirleri almakla yükümlüdür. Ancak, mücbir sebepler,
            teknik arızalar, üçüncü kişilerin hukuka aykırı fiilleri veya UPT’nin kontrolü dışında
            gelişen nedenlerle meydana gelen kesinti, gecikme veya aksaklıklardan dolayı sorumluluk
            kabul etmez.
          </Typography>
          <Typography>
            <strong>3.3.6. </strong>Müşteri tarafından, Müşterinin gerçekleştirdiği Ödeme İşlemine
            bağlı olarak gerçekleştirilen Alacak Transferi veya para çekme işlemi için olan olağan
            Komisyon Ücretini ödenir. Alacak Transferine veya para çekme işlemine ilişkin standart
            Komisyon Ücretleri uygulanacaktır. Standart Komisyon Ücretleri, Web Sitesi üzerinden ve
            geçerli işlem ücreti de dahil olmak üzere, başlatılan Ödeme İşlemi ile ilgili tüm
            bilgileri gösterecek olan Ödeme İşleminin işleme konması sırada Müşteriye gösterilecek
            olan ekran üzerinden olmak üzere iki kanal aracılığıyla sunulacaktır.
          </Typography>
          <Typography>
            <strong>3.3.7 </strong>Müşteri, ödeme hesabına ilişkin olarak gerçekleştirilen tüm
            işlemlerin, UPT sistemlerinde tutulan kayıtlar esas alınarak değerlendirileceğini ve bu
            kayıtların, uyuşmazlık halinde kesin delil teşkil edeceğini kabul eder.
          </Typography>
          <Typography>
            <strong>3.3.8 </strong>UPT, mevzuat, kamu otoritelerinin talimatları veya risk yönetimi
            gereklilikleri doğrultusunda, ödeme hesabının kullanımını geçici olarak sınırlandırma,
            askıya alma ve durdurma hakkını saklı tutar. Bu tür durumlarda, mümkün olan hallerde
            müşteri bilgilendirilir.
          </Typography>

          <Typography variant="h4">3.4. Ödeme Emirlerinin Alınma Zamanı</Typography>
          <Typography>
            <strong>3.4.1. </strong>Ödeme talimatının alınmasında ve ödeme işleminin
            gerçekleştirilmesinde kapanış (cut-off) saatleri dikkate alınır.
          </Typography>
          <Typography>
            <strong>3.4.2. </strong>Herhangi bir Kanal aracılığıyla olsun veya olmasın, Ödeme
            Emrinin alındığı zamanın, UPT tarafından tesellüm edildiğinin kayıt altına alınmış
            olduğu zaman olduğu addedilir.
          </Typography>
          <Typography>
            <strong>3.4.3. </strong>Ödeme Emri yoluyla başlatılan Ödeme İşleminin
            gerçekleştirilmesine ilişkin süre, söz konusu Ödeme Emrinin, İş Gününde ve detayları
            3.5.12. maddesinde belirtilen ilgili Kapanış Zamanı öncesinde tesellüm edilmesi
            koşuluyla, Ödeme Emrinin UPT tarafından tesellüm edildiği gün başlayacaktır. Ödeme
            Emrinin, İş Günü dışında verilmesi veya ilgili Kapanış Zamanından sonra tesellüm
            edilmesi halinde, Ödeme Emrinin, bir sonraki İş Gününde tesellüm edilmiş olduğu
            addedilir.
          </Typography>
          <Typography>
            <strong>3.4.4. </strong>Müşteri tarafından, UPT tarafından düzenlendiği ve belirtildiği
            şekilde, Ödeme Emrinin gerçekleştirilmesinin belirli bir günde, belirli bir sürenin
            sonunda veya UPT tarafından kabul edilmesi halinde, Müşteri tarafından tutarların
            UPT'nin tasarrufuna bırakıldığı günde başlatılması talep edilebilecektir. Söz konusu
            Ödeme Emrinin tesellüm edildiği tarih, Ödeme Emrinin gerçekleştirilmesine ilişkin olarak
            kararlaştırılan gün olarak değerlendirilecektir. Talep edilen günün, İş Gününe tekabül
            etmemesi halinde, Ödeme Emrinin, bir sonraki İş Gününde tesellüm edilmiş olduğu
            addedilecektir. Herhangi bir takvim ayında, belirli bir tutarın belirli aralıklarla
            transfer edilmesi amacıyla herhangi bir Ödeme Emrinin gerçekleştirilmesinin planlandığı
            tarihten daha az gün olması halinde, söz konusu Ödeme Emrinin gerçekleştirilmesi o ayın
            son İş Gününde başlayacaktır.
          </Typography>
          <Typography>
            <strong>3.4.5. </strong>Kapanış Zamanları gelen Ödeme İşlemleri için de geçerlidir. Söz
            konusu işlemin, İş Gününde tesellüm edilmemesi veya ilgili Kapanış Zamanından sonra
            tesellüm edilmesi halinde, Ödeme Emrinin, bir sonraki İş Gününde tesellüm edilmiş olduğu
            addedilir.
          </Typography>

          <Typography variant="h4">
            3.5. Ödeme Emirlerinin Verilmesi ve Ödeme İşlemlerinin Gerçekleştirilmesi
          </Typography>
          <Typography>
            <strong>3.5.1. </strong>Müşteri tarafından Hesaptan Ödeme Talimatları aşağıdaki yollarla
            verilebilir ve yine aşağıdaki yollarla Ödeme İşlemleri başlatılabilir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Profiline giriş yapılarak Web Sitesi üzerinden;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşteriye temsile yetkili kişi/kişiler tarafından yazılı ve ıslak imzalı olarak UPT
              Şubelerine ve/veya UPT Operasyon Birimi’ne iletilen yazılı talimat üzerinden.
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Profiline giriş yapılarak Uluslararası Ödeme Transferi Sistemi üzerinden.
            </ListItem>
          </List>
          <Typography>
            <strong>3.5.2. </strong>Hesaptan Ödeme İşlemleri aşağıdaki şekilde gerçekleştirilebilir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>Aynı Müşterinin Hesapları arasında;</ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Farklı Müşterilerin Hesapları arasında;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Türkiye'deki diğer bankalar nezdinde açılan hesaplara;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Yabancı ülkelerdeki, Ödeme İşlemlerinin yasaklandığı bankalar hariç olmak üzere,
              (desteklendiği hallerde) yabancı bankalar nezdinde açılan hesaplara: Müşteri, UPT
              tarafından Sistemdeki bu tür ülkeler hakkında bilgilendirilir).
            </ListItem>
          </List>
          <Typography>
            <strong>3.5.3. </strong>EUR, ABD DOLARI ve TL cinsinden ödemeler Sistem dahilinde
            sağlanacaktır.
          </Typography>
          <Typography>
            <strong>3.5.4. </strong>Yabancı para hesaplardan (EUR ve USD) yapılan tüm ödemeler ve
            muameleler, hesap hangi para türü üzerinden açılmış ise o para türü üzerinden yapılır.
            Bununla beraber T.C. Kanunlarının veya sair mevzuatın emredici ve zorlayıcı hükümler
            getirmesi halinde veya UPT dilerse, söz konusu hesap yabancı bir para ile açılmış olsa
            dahi Türk parasıyla ödeme yapılır. Bununla birlikte, Müşteri herhangi bir hesabından
            farklı bir döviz cinsi ile transfer ve ödeme yapılabilecek (TL hesabından USD ve/veya
            EUR ödemesi vb.) olup söz konusu işleme ilişkin kur farkı Müşteriye yansıtılarak oluşan
            fark Müşteri hesabından tahsil edilecektir. Bu hesaplara yurt içinden, yurt dışına
            gönderilmek üzere gelen/yatırılan dövizin en geç ertesi iş günü sonu itibarıyla hesaptan
            çıkmış olması gerekmektedir. Yurt içinden hesaba gelmiş ve ertesi iş günü sonu
            itibarıyla halen hesapta bulunan döviz bakiyeleri UPT tarafından TCMB döviz alış
            kurundan TL’ye çevrilecek ve çevrilen tutar müşterinin TL hesabına aktarılacaktır. Bu
            hesaplara yurt dışından yurt içine gönderim yoluyla döviz transferi geldiğinde ise gelen
            tutarın en geç bir ay içerisinde hesaptan çıkmış olması gerekmektedir. Yurt dışından
            hesaba gelmiş ve bir ay sonrasında halen hesapta bulunan döviz bakiyeleri UPT tarafından
            TCMB alış döviz kurundan TL’ye çevrilecek ve çevrilen tutar müşterinin TL hesabına
            aktarılacaktır.
          </Typography>
          <Typography>
            <strong>3.5.5. </strong>Yukarıdaki 3.5.2 sayılı madde kapsamında belirtilen herhangi bir
            Ödeme İşlemini gerçekleştirmek üzere, Müşteri tarafından Ödeme Emrinin verilmesi
            sonrasında Hesap ekranında açılacak olan talimatlar takip edilmelidir.
          </Typography>
          <Typography>
            <strong>3.5.6. </strong>Ödeme Emri verilmesi için müşterinin kendisine Kurye aracılığı
            ile gönderilmiş olan GÖHS’yi imzalaması (ıslak imza), UPT’ye teslimi ve sözleşme onayı
            zorunludur. Müşteri, UPT personelinin huzurunda da GÖHS’yi imzalayabilir.
          </Typography>
          <Typography>
            <strong>3.5.7. </strong>Her bir Ödeme İşleminin gerçekleştirilmesi amacıyla, Müşteri
            tarafından Müşteri ile bağlantılı Kişiselleştirilmiş Güvenlik Özellikleri kullanılarak
            doğrulanması gerekecektir (daha ayrıntılı bilgi için bakınız GÖHS'nin aşağıdaki
            "Yetkilendirme" maddesi).
          </Typography>
          <Typography>
            <strong>3.5.8. </strong>Döviz işlemleri UPT'nin çevrim sırasında geçerli olan döviz
            kuruna dayalıdır (döviz kurları derhal ve ayrı bir bildirimde bulunulmaksızın
            uygulanır). Geçerli döviz kuru, Müşteriye çevrim sırasında Hesap ekranında
            gösterilecektir.
          </Typography>
          <Typography>
            <strong>3.5.9. </strong>Müşteri tarafından UPT mobil uygulamasına giriş yapılarak
            Müşterinin Hesaptaki Ödeme Emirlerinin durumu dilediği zaman görülebilecektir.
          </Typography>
          <Typography>
            <strong>3.5.10. </strong>Müşterinin ödeme yapan/borçlu olması halinde, Ödeme İşleminin
            Müşteri tarafından Sisteme girilen Ödeme Emrinin detayları takip edilerek
            gerçekleştirilebilmesi amacıyla Müşteri ödeme alan/alacaklı hakkında detaylı ve kesin
            bilgi sunmakla yükümlüdür. Ödeme alanın/alacaklının ödeme hizmetleri sağlayıcısı
            tarafından gerekli görülmesi halinde, Ödeme Yapan/Borçlu olarak hareket eden Müşteriden
            UPT tarafından Müşterinin Ödeme Emri işlemine devam edilmesine imkân verecek ek verileri
            girmesi talep edilebilecektir. Doğru ek bilgilerin girilmesinden Müşteri tek başına
            sorumludur.
          </Typography>
          <Typography>
            <strong>3.5.11. </strong>UPT Ödeme İşleminin ödeme alanın/alacaklının ödeme hizmetleri
            sağlayıcısı tarafından tesellüm edilmiş olduğundan haberdar olmadığı ve bunu
            kanıtlayamadığı sürece – ki bu durumda Ödeme İşleminin gerektiği şekilde
            gerçekleştirilmesinden ödeme alanın/alacaklının ödeme hizmetleri sağlayıcısı sorumlu
            olacaktır – GÖHS ve 6493 sayılı Ödeme ve Menkul Kıymet Mutabakat Sistemleri, Ödeme
            Hizmetleri ve Elektronik Para Kuruluşları Hakkında Kanun gereğince Ödeme İşleminin
            gerektiği şekilde ve usulüne uygun olarak gerçekleştirilmesinden UPT sorumlu olacaktır.
            Ödeme İşleminin gerçekleştirilmemiş olması veya zamanında ve usulüne uygun olarak ve
            GÖHS gereğince gerçekleştirilmemiş olması halinde, UPT aşağıdaki hususları yerine
            getirmekle yükümlü olacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Söz konusu Ödeme İşlemini takiben transfer edilen tutarın Hesaba iade edilmesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Hesaptaki Bakiyenin Ödeme İşlemi gerçekleştirilmemiş gibi eski haline geri getirilmesi
              ve
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşteriye belirli bir süreye ilişkin olarak faiz ödenmemesi veya müşteriden belirli
              bir süreye ilişkin faiz alınmaması (durum ne olursa olsun) ile ilgili olarak hiçbir
              zarar görmemesinin sağlanması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Yukarıda belirtilen durumda UPT söz konusu Ödeme İşlemini takip etmek üzere elinden
              gelen gayreti sarf edecektir ve böyle bir geri çekmeye ilişkin olarak hiçbir ücret
              uygulanmayacaktır.
            </ListItem>
          </List>
          <Typography>
            <strong>3.5.12. </strong>Müşteri tarafından verilen Ödeme Emirleri UPT tarafından
            aşağıdaki sürelerde gerçekleştirilecektir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              UPT’de tutulan Hesaplar arasındaki Ödeme Emirleri 7/24/365 esasına dayalı herhangi bir
              kapanış (cut off) saatine tabi olmaksızın anında gerçekleştirilecektir;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Türkiye Cumhuriyeti sınırları dahilinde gerçekleştirilecek olan ve en geç 16:30'da
              verilen TL cinsinden Ödeme Emirleri aynı İş Gününde (Ödeme Emrinin İş Gününde
              verilmemesi halinde, en geç sonraki ilk İş Gününde) gerçekleştirilecektir;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Türkiye Cumhuriyeti sınırları dahilinde gerçekleştirilecek olan ve 16:30'dan sonra
              verilen TL cinsinden Ödeme Emirleri en geç bir sonraki İş Gününde (Ödeme Emrinin İş
              Gününde verilmemesi halinde, en geç sonraki ilk İş Gününde) gerçekleştirilecektir;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Diğer Ödeme Emirleri en fazla 4 (dört) İş Günü içerisinde gerçekleştirilebilecektir.
            </ListItem>
          </List>
          <Typography>
            <strong>3.5.13. </strong>Tutarların UPT tarafından Müşteri hesabına en geç öğlen
            12.00'ye kadar tesellüm edilmesi halinde, söz konusu tutarlar UPT tarafından en geç aynı
            İş Gününde Müşterinin Hesabına alacak kaydedilecektir; tutarların UPT tarafından öğlen
            12.00'den sonra tesellüm edilmesi halinde, söz konusu tutarlar en geç bir sonraki İş
            Gününde Müşterinin Hesabına alacak kaydedilecektir.
          </Typography>
          <Typography>
            <strong>3.5.14. </strong>Müşteri tarafından UPT'ye eksiksiz, doğru, açık ve tam Ödeme
            Emirleri sunulacaktır. Bu emirler ödeme işleminin gerçekleştirilebilmesi için gerekli
            olan bilgileri (lehtarın adı, hesap numarası, tutar vb.) UPT, Müşteri tarafından verilen
            Ödeme Emirlerinde yer alan bilgiler doğrultusunda hareket etmeye ve söz konusu bilgilere
            itimat etmeye yetkilidir. Müşteri tarafından yanlış bir Ödeme Emrinin sunulması veya
            Ödeme Emrinde yanlış verilerin belirtilmesi ve böyle bir Ödeme Emrini takiben Ödeme
            Transferinin henüz gerçekleştirilmemiş olması halinde, Ödeme Emri, Müşteri tarafından
            Komisyon Ücreti geri alınmadan iptal edilebilecektir.
          </Typography>
          <Typography>
            <strong>3.5.15. </strong>Ödeme Emirleri UPT tarafından Lehtar adına ve/veya adresine
            dayalı olarak değil, Özgün Tanımlayıcı esas alınarak gerçekleştirilecektir. UPT
            tarafından Ödeme Emrinin Müşteri tarafından belirtilen Özgün Tanımlayıcı esas alınarak
            gerçekleştirilmesi halinde, söz konusu Ödeme Emrinin doğru bir şekilde
            gerçekleştirildiği addedilir. Bu tür bilgilerin kanunlar veya düzenlemeler uyarınca
            gerekli olduğu hallerde dahi Müşterinin veya Lehtarın adı veya adresi Özgün Tanımlayıcı
            kapsamında değildir. UPT, Müşteri tarafından belirtilen Özgün Tanımlayıcı ile adı veya
            adresi gibi Lehtarı tanımlayabilecek diğer bilgiler arasındaki tutarsızlıkları kontrol
            etmekle yükümlü olmayacaktır. Müşteri tarafından belirtilen Özgün Tanımlayıcının Müşteri
            tarafından amaçlanan Lehtara ait olmaması halinde, Ödeme Emrinin gerçekleştirilmesinden
            doğan sonuçlardan UPT sorumlu değildir. Bununla birlikte, talep edilmesi halinde,
            gerçekleştirilen Ödeme İşlemi ile bağlantılı olarak tutarların geri ödenmesi için UPT
            tarafından makul gayret sarf edilecektir. UPT tarafından bu tür geri ödeme ile ilgili
            olarak altına girilen makul giderler Müşteriye yansıtılabilecektir.
          </Typography>
          <Typography>
            <strong>3.5.16. </strong>UPT'nin Müşteri tarafından başlatılan Ödeme İşlemini
            gerçekleştirmeyi reddetmesi halinde (reddetmeye ilişkin gerekçe hakkında daha fazla
            bilgiye GÖHS'nin aşağıdaki 3.9 sayılı maddesinden ulaşılabilir), UPT, söz konusu reddin
            nedenlerini belirterek Müşteriyi söz konusu ret hakkında bilgilendirecek ve yürürlükteki
            kanunlar kapsamında cevaz verilmesi halinde, tespit edilen hataların nasıl
            giderilebileceği hususunda Müşteriyi yönlendirecektir. Müşteriye 3.5.12 sayılı madde
            kapsamında belirtilen sürelerden geç olmamak üzere bildirimde bulunulacaktır. Ödeme
            İşleminin gerçekleştirilmesinin reddinin makul olması halinde, UPT tarafından Müşteriye
            Ödeme İşleminin gerçekleştirilememesine sebebiyet veren Ödeme Emrinin yanlış
            verilmesinden dolayı ücret uygulanabilecektir.
          </Typography>
          <Typography>
            <strong>3.5.17. </strong>Paranın Hesabına yanlışlıkla veya yasal dayanağı olmayan başka
            bir şekilde alacak kaydedildiğini veya Hesabından yanlışlıkla veya böyle bir şekilde
            kesildiğini fark eden Müşteri bu hususta UPT'yi haberdar etmekle yükümlüdür. Müşteri
            kendisine ait olmayan para üzerinde tasarrufta bulunma hakkına sahip değildir. Bu gibi
            hallerde, UPT, Müşterinin talimatı olmaksızın Müşterinin Hesabından para kesme hakkına
            sahiptir, Müşteri de bu hususa ilişkin olarak gayrikabili rücu olarak muvafakat
            etmektedir. Müşterinin Hesabındaki para tutarının yanlışlıkla Müşterinin Hesabına alacak
            kaydedilen paranın borç kaydedilmesine yeterli olmaması halinde, Müşteri bu parayı
            UPT'nin bu husustaki talebinin tesellümünden itibaren 3 (üç) İş Günü içerisinde UPT'ye
            geri ödeyeceğini koşulsuz olarak taahhüt etmektedir. Müşterinin Hesabına yanlışlıkla
            alacak kaydedilen parayı zamanında iade etmemesi halinde, UPT'nin talebi üzerine Müşteri
            tarafından UPT'ye zaman sınırının aşılmış olduğu beher gün için yüzde 0,05 oranında
            günlük cezai şart ödenecektir. addedilir.
          </Typography>
          <Typography>
            <strong>3.5.18. </strong>GÖHS'yi kabul etmekle Müşteri bu vesileyle, Hesap Bakiyesini
            sürekli olarak izleyeceğine ve Müşterinin Ödeme Emirlerinin gerçekleştirilmesi için
            gerekli olan Bakiyenin Ödeme Emri verildikten sonra kullanılabilir olmasını
            sağlayacağına muvafakat etmektedir. UPT, Müşterinin Hesabının Bakiyesini izlemeyi ve
            Müşteriye bu hususa ilişkin herhangi bir şekilde bildirim göndermeyi taahhüt
            etmemektedir.
          </Typography>
          <Typography>
            <strong>3.5.19. </strong>Ödeme Hesap Bakiyesi ve geçmişi Müşteri tarafından Müşterinin
            Profiline giriş yapılarak kontrol edilebilecektir. Gerçekleştirilen ve tesellüm edilen
            işlemlere ilişkin bilgiler UPT tarafından Profil aracılığıyla mevcut olan Müşterinin
            Hesap Özetinde sunulur. Müşteri, Profiline giriş yapabilecek ve bu bilgileri ücretsiz
            olarak görüntüleyebilecek veya seçilen sıklıkta indirebilecektir. Seçilen süre boyunca
            uygulanan tüm Komisyon Ücretleri ve Müşterinin Hesabından kesilen diğer ücretler
            hakkında da bilgiler mevcuttur.
          </Typography>
          <Typography>
            <strong>3.5.20. </strong>Herhangi bir Ödeme Emrinin başlatılması için üçüncü taraf bir
            Kanalın kullanılması halinde, UPT tarafından ilgili Ödeme Emrinin tesellüm edilmesine
            müteakiben Müşteri tarafından Ödeme Emrinin gerçekleştirilmesine muvafakat edilmiş
            olduğu addedilir.
          </Typography>
          <Typography>
            <strong>3.5.21. </strong>UPT, Ödeme Emrinin kullanımına ve şekline ilişkin gereklilikler
            ve sınırlamalar belirlemeye ve başka talimatlar vermeye yetkilidir.
          </Typography>
          <Typography variant="h4">
            3.6. Ödeme İşleminin Gerçekleştirilmesi Sonrasında Sunulan Bilgiler
          </Typography>
          <Typography>
            <strong>3.6.1. </strong>Müşterinin Ödeme Emrini takiben Hesaptan ilgili tutarın
            kesilmesinin ardından, UPT tarafından Müşteriye, Profili aracılığıyla Müşteriye
            sunulabilecek aşağıdaki bilgiler sunulacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Transfer edilen tutar, tarih, Müşteri tarafından yer verilen ödeme bilgileri ve ödeme
              alanın/alacaklının Özgün Tanımlayıcısı da dahil olmak üzere, Müşteri tarafından ödeme
              işleminin tanımlanmasına imkân veren bilgiler;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Emrinde belirtilen para birimi cinsinden ifade edilen Ödeme İşlemi tutarı;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme İşlemine ilişkin olarak Müşteri tarafından ödenmesi gereken komisyon tutarı ve
              komisyon ücretinin nasıl bölündüğü ile ilgili bilgiler (uygun olması halinde);
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT tarafından kullanılan döviz kuru ve söz konusu döviz işleminin gerçekleştirilmesi
              sonrasındaki Ödeme İşleminin tutarı (döviz işleminin gerçekleştirilmesi halinde).
            </ListItem>
          </List>
          <Typography>
            <strong>3.6.2. </strong>Müşterinin ödeme alan/alacaklı olması halinde, UPT tarafından
            Müşterinin gelen Ödeme İşlemi ile ilgili olarak aşağıdaki bilgileri tesellüm etmesi
            sağlanacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme İşleminin tutarı, para birimi, dekont tarihi, ödeme alan/alacaklı, ödeme
              yapan/borçlu tarafından sağlanan ödeme bilgileri de dahil olmak üzere Müşteri
              tarafından Ödeme İşleminin tanımlanmasını sağlayan bilgiler;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Yapanın/Borçlunun Özgün Tanımlayıcısı da dahil olmak üzere ödeme alan/alacaklı
              tarafından ödeme yapanın/borçlunun tanımlanmasına imkân veren bilgiler;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödemenin amacı da dahil olmak üzere Ödeme İşlemi ile iletilen veriler;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme İşleminin, tutarın Müşterinin hesabına alacak kaydedildiği para birimindeki
              tutarı;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Mevcut olması halinde, Ödeme İşlemine ilişkin olarak Müşteri tarafından ödenmesi
              gereken komisyon tutarı ve komisyon ücretinin ve mevcut ise Müşteri tarafından ödenen
              faizin nasıl bölündüğü ile ilgili tanımlama;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT tarafından kullanılan döviz kuru ve döviz çevriminin yapılmasına kadarki para
              tutarı (döviz çevriminin yapılması halinde); Tutarların alacak kaydedildiği tarih.
            </ListItem>
          </List>
          <Typography variant="h4">3.7. Kayıt Tarihi ve Valör</Typography>
          <Typography>
            <strong>3.7.1. </strong>UPT tarafından Hesaba alacak kaydedilecek TRY cinsinden herhangi
            bir tutar alındığında, bu tutar UPT tarafından aynı İş Gününde alacak kaydedilecektir.
            Bu durumda, Valör Kayıt Tarihi ile aynıdır. UPT tarafından Hesaba alacak kaydedilecek
            TRY para birimi dışındaki herhangi bir para birimi cinsinden herhangi bir tutar
            alındığında, Kayıt Tarihi Valörden farklı olabilir.
          </Typography>
          <Typography>
            <strong>3.7.2. </strong>UPT tarafından Hesaptan herhangi bir Ödeme İşlemi
            gerçekleştirildiğinde UPT tarafından Hesap, 3.5.2 sayılı Maddeye uygun olarak UPT
            tarafından gerçekleştirmenin başlatıldığı İş Gününde borçlandırılır. Bu durumda, Valör
            Kayıt Defteri ile aynı tarihtir.
          </Typography>

          <Typography variant="h4">3.8. Ödeme Emirlerinin İptali</Typography>
          <Typography>
            Ödeme Hizmetleri Belgeleri kapsamında aksi belirtilmediği sürece, UPT tarafından
            tesellüm edilmeleri sonrasında Ödeme Emirleri gayrikabili rücu niteliktedir. Bununla
            birlikte, UPT tarafından herhangi bir planlanmış gerçekleştirme tarihine sahip olarak
            herhangi bir Kanal vasıtasıyla tesellüm edilen Ödeme Emirleri, bu tür iptalin,
            planlanmış gerçekleştirme tarihinin Kapanış Zamanından bir İş Günü önce UPT tarafından
            tesellüm edilmiş olması koşuluyla, UPT mobil uygulaması üzerinden Müşteri tarafından
            iptal edilebilecektir.
          </Typography>
          <Typography variant="h1"> </Typography>

          <Typography variant="h4">
            3.9. Ödeme Emirlerinin Reddedilmesi, Askıya Alınması ve İletilmesi
          </Typography>
          <Typography>
            <strong>3.9.1. </strong>Aşağıdaki hallerde, UPT (tümüyle veya kısmen) herhangi bir Ödeme
            Emrini (i) gerçekleştirmeyi veya iletmeyi reddedebilecek veya (ii) herhangi bir Ödeme
            Emrinin gerçekleştirilmesini veya iletilmesini askıya alabilecektir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Emrinin eksik, yanlış, belirsiz olması veya kesin olmaması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Emrinin geçerliliğine veya Ödeme Emrini veren şahsın kimliğine veya yetkisine
              ilişkin herhangi bir şüphenin olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              İlgili Müşterinin vekaletnamesinin/imza sirküsünün tadil edilmiş, iptal edilmiş olması
              veya başka bir şekilde artık geçerli olmaması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Hesaptaki Kullanılabilir Bakiyenin yetersiz olması veya Ödeme Emrinin, UPT tarafından
              belirlenen geçerli tek işlem tutarı, günlük işlem tutarı ve günlük işlem adedi
              limitini aşması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Hesabın bloke edilmiş veya haczedilmiş olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Hesaba ilişkin olarak mahsup etme veya hapis hakkının mevcut olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Emrinin geçerli kanunları veya düzenlemeleri veya UPT’nin iç politikasını ihlal
              eder nitelikte olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Mevzuat ile yasaklanmış olan (yasadışı bahis ve şans oyunları vb.) ya da genel ahlak
              kurallarına ters düşen, ürünlere veya hizmetlere ilişkin olduğunun tespiti halinde.
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Emrinin UPT ile Müşteri arasında akdedilen herhangi bir sözleşmeyi ihlal eder
              nitelikte veya böyle bir sözleşmeye aykırı nitelikte olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Emrinin UPT'ye serbest bir şekilde kullanılamayan bir para birimine ilişkin
              olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT tarafından üçüncü taraf bir Kanal vasıtasıyla tesellüm edilsin veya edilmesin,
              Ödeme Emrinin UPT'nin şekil, biçim ve/veya diğer gerekliliklerine uygun olmaması veya
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Söz konusu şüphenin dayanaksız olduğu kanıtlanıncaya kadar, herhangi bir Ödeme
              Aracının yetkisiz veya hileli bir şekilde kullanıldığına veya güvenliğine ilişkin
              usulsüzlüklerin mevcut olduğuna dair herhangi bir şüphenin olması.
            </ListItem>
          </List>
          <Typography>
            <strong>3.9.2. </strong>3.9.1 sayılı Madde kapsamında belirtilen hallerde, Ödeme Emrinin
            gerçekleştirilmemesinden veya zamanında gerçekleştirilmemesinden kaynaklanan zarar
            ve/veya ziyandan UPT sorumlu tutulmayacaktır.
          </Typography>
          <Typography>
            <strong>3.9.3. </strong>Geçerli kanunlar veya düzenlemeler kapsamında yasaklanmadığı
            sürece, UPT tarafından Müşteriye herhangi bir Ödeme Emrinin gerçekleştirilmesinin veya
            iletilmesinin reddi ve mümkün olması halinde, söz konusu reddin nedenleri ile redde yol
            açan gerçeğe dayalı yanlışlıkların düzeltilmesine ilişkin usul ile ilgili olarak
            bildirimde bulunulacaktır. UPT tarafından Tarifeler ve Koşullar kapsamında belirtildiği
            üzere, Müşteriden herhangi bir Ödeme Emrinin reddin ilişkin bildirim için ücret
            alınabilecektir. Müşteriye bu hususta en geç 3.5.12 sayılı madde kapsamında belirtilen
            süreler içerisinde olmak üzere bildirimde bulunulacaktır.
          </Typography>
          <Typography>
            <strong>3.9.4. </strong>UPT tarafından Ödeme İşlemlerine ilişkin itiraz kayıtları
            oluşturulabilecektir. Herhangi bir Ödeme Emrinin İş Günü olmayan bir günde veya Kapanış
            Zamanından sonra tesellüm edilmesi halinde, mevcut olması halinde, derhal bir ihtiraz
            kaydı oluşturulur ve gerçekleştirme bir sonraki İş Gününde başlayacaktır. İhtiraz kaydı,
            Kullanılabilir Bakiyeyi ihtiraz kaydının ilgili olduğu Ödeme İşlemi tutarı doğrultusunda
            azaltır veya arttırır.
          </Typography>

          <Typography variant="h4">
            3.10. Hesabın Para Birimi ve Yabancı Para Birimindeki Ödeme Emirlerinin
            Gerçekleştirilmesi
          </Typography>
          <Typography>
            <strong>3.10.1. </strong>Hesaplar EURO, ABD DOLARI ve TL cinsinden açılabilir. Hesaptaki
            Bakiye Sözleşmede belirtilen para biriminde tutulur.
          </Typography>
          <Typography>
            <strong>3.10.2. </strong>Ödeme Emirleri TRY, EUR ve USD cinsinden gerçekleştirilebilir.
            Diğer para birimlerindeki Ödeme Emirleri UPT tarafından reddedilecektir.
          </Typography>
          <Typography>
            <strong>3.10.3. </strong>Müşteri tarafından Hesabın para birimi olmayan herhangi bir
            para birimi cinsinden tutarların ödenmesi veya tesellüm edilmesi halinde, UPT tarafından
            Hesaba söz konusu tutarların Hesabın para birimindeki muadil değeriyle borç veya alacak
            kaydedilecektir. Söz konusu muadil değer, UPT tarafından belirlenen bir döviz kuru esas
            alınarak tespit edilecektir.
          </Typography>
          <Typography>
            <strong>3.10.4. </strong>UPT dilediği zaman döviz kurlarını derhal yürürlüğe girecek
            şekilde ve önceden bildirimde bulunmaksızın değiştirebilecektir. Döviz kurları UPT
            tarafından günlük veya daha sık aralıklar esas alınarak belirlenir. Geçerli kura ilişkin
            bilgiler UPT'nin mobil uygulaması UPTION/web şubesinde/ Uluslararası Ödeme Transferi
            içinde Kur Bilgisi bölümünde mevcuttur.
          </Typography>
          <Typography>
            <strong>3.10.5. </strong>Buna herhangi bir kanunun, emrin, düzenlemenin, kararnamenin
            veya idari işlemin (bunların yürürlüğe konmasının veya tadil edilmesinin) ve/veya
            herhangi bir hükümetin, merkez bankasının veya bu yetkiye sahip olduğunu iddia eden
            herhangi bir diğer organın emri gereğince veya kapsamında herhangi bir müdahalenin veya
            fiilin veya ihmalin sebebiyet vermesi halinde, herhangi bir Ödeme Emrinin
            gerçekleştirilmemesi veya kusurlu olarak gerçekleştirilmesi neticesinde Müşteri
            tarafından altına girilen zarar ve/veya ziyadan UPT sorumlu olmayacaktır. Buna ilaveten,
            ilgili para birimini kullanan veya söz konusu Hesabın tutulduğu ülkedeki hükümet, merkez
            bankası veya söz konusu yetkiye sahip olduğunu iddia eden herhangi bir diğer organ
            tarafından Hesabın veya Bakiyenin müsaderesi, kamulaştırılması, istimlakı, istimvali,
            haczi, mahrumiyeti sonucunda Müşteri tarafından altına girilen zarar ve/veya ziyadan UPT
            sorumlu olmayacaktır.
          </Typography>
          <Typography>
            <strong>3.10.6. </strong>Bakiyeyi muhafaza etmek ve Ödeme İşlemlerini Hesabın tutulduğu
            yargı yetki bölgesinin meşru para birimi dışındaki para biriminde gerçekleştirmek
            amacıyla UPT, söz konusu para biriminin kullanıldığı ülkedeki herhangi bir banka veya
            Ödeme Hizmetleri Sağlayıcısı (PSP) nezdinde muhabir hesaba sahip olacaktır. UPT ile söz
            konusu banka/Ödeme Hizmetleri Sağlayıcısı (PSP) arasındaki muhabir hesaba ilişkin
            sözleşmenin sona ermesi veya her ne sebeple olursa olsun fesih edilmesi halinde, Hesaba
            ilişkin Sözleşme ve/veya Ödeme Hizmeti UPT tarafından derhal geçerli olmak üzere fesih
            edilebilecektir.
          </Typography>

          <Typography variant="h4">3.11. Hesabın Askıya Alınması</Typography>
          <Typography>
            <strong>3.11.1. </strong>UPT, aşağıdaki hallerde, Hesabı ve Müşteriye ihraç olunan ödeme
            araçlarını askıya alma (bloke etme) hakkına sahip olacaktır:
          </Typography>
          <Typography>
            Müşterinin talep edilen bilgileri, verileri ve/veya belgeleri böyle bir talepte
            belirtilen süre içerisinde UPT'ye sunmaması;
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Sözleşme kapsamında öngörülen şartlar ve hükümler gereğince, zamanında ve
              usulüne uygun olarak UPT ile hesap tasfiyesi yapmaması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin Hesaptaki tutarların kaynağı hakkında makul şüphelerinin olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Mevzuat ile yasaklanmış olan (yasadışı bahis ve şans oyunları vb.) ya da genel ahlak
              kurallarına ters düşen, ürünlere veya hizmetlere ilişkin olduğunun tespiti;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin Ödeme Emri ile ilgili makul şüphelerinin olması (başka bir ifadeyle; makul
              olması, amacı, meşruluğu vb.);
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin Hesap üzerinden kara paranın aklanmasının veya terörizmin finansmanının
              yapılmış olduğundan veya yapılmasının amaçlandığından şüphe edilmesine yönelik olarak
              makul gerekçelerinin olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin Müşterinin UPT Ödeme Hesabına erişimine imkân veren Kişiselleştirilmiş
              Güvenlik Özelliklerinin çalındığından, kaybolduğundan veya kötüye kullanıldığından
              haberdar olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin Hesabın Müşteriden ziyade başka şahıslar tarafından kullanıldığının
              düşünülmesi için makul gerekçelerinin olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Uluslararası Ödeme Transfer Sistemi’ni UPT’nin yazılı onayı olmadan üçüncü
              tarafların kullanımına açmış olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Hesabı UPT'nin önceden onayını gerektirecek şekilde kullanması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin Müşterinin Sözleşme kapsamındaki yükümlülüklerini gerektiği şekilde yerine
              getirmesini engelleyebilecek diğer koşullardan haberdar olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Hesabın Müşteri tarafından Sözleşmenin ve/veya geçerli kanunun hükümlerine aykırı bir
              şekilde kullanılması ve
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin geçerli kanun gereğince bu yönde hareket etmekle yükümlü olması.
            </ListItem>
          </List>
          <Typography>
            <strong>3.11.2. </strong>Yukarıdaki liste geneli kapsar nitelikte değildir ve UPT
            tarafından Müşterinin ve/veya UPT'nin ve/veya UPT'nin diğer Müşterilerinin
            menfaatlerinim korunması için gerekli görülmesi halinde, UPT herhangi bir başka
            gerekçeyle Hizmetlerin Müşteri tarafından kullanılmasını askıya alma hakkına sahip
            olacaktır. Her halükârda UPT, 30 (otuz) günden uzun olmayacak makul bir süreyle Hesabı
            askıya alma hakkına ve söz konusu süreyi, aynı süre kadar, sınırsız olarak uzatma
            hakkına sahiptir. Hizmetlerin kullanımının askıya alınması, söz konusu sınırlama
            gerekçesinin ortadan kalkmasına müteakiben sonlandırılacaktır. Belirli hallerde, durumun
            vahametine bağlı olarak yukarıdaki koşullar Sözleşmenin UPT tarafından derhal yürürlüğe
            girecek şekilde tek taraflı olarak feshedilmesi ile sonuçlanabilecektir.
          </Typography>
          <Typography>
            <strong>3.11.3. </strong>Askıya almaya yol açan sebebe bağlı olarak geçerli kanunlar
            kapsamında bu şekilde hareket etme hakkına sahip olduğu sürece, UPT tarafından Hesabın
            askıya alınmasına ilişkin koşullar açıklanabilecek ve buna göre Müşteriye mevcut durumun
            nasıl iyileştirileceği ile ilgili talimatlar verilebilecektir.
          </Typography>
          <Typography>
            <strong>3.11.4. </strong>Hizmetlerin Müşteri tarafından kullanılmasının askıya alınması
            için UPT'nin gerekçelendirilmiş bir sebebe sahip olması koşuluyla, Hizmetlerin
            kullanılmasının askıya alınması ile ilgili olarak Müşteri tarafından maruz kalınan zarar
            veya ziyandan UPT sorumlu olmayacaktır.
          </Typography>

          <Typography variant="h4">3.12. Üçüncü Taraflarca Gerçekleştirilen Ödemeler</Typography>
          <Typography>
            Ödemelerin Müşterinin Hesabına alacak kaydedilmesi Müşteri tarafından engellenemez.
            Bununla birlikte, UPT böyle bir hakka sahip olacaktır (örneğin; kara paranın
            aklanmasının ve terörizmin finansmanın önlenmesine ilişkin gereklilikler kapsamında
            talep edildiği hallerde).
          </Typography>
          <Typography variant="h4">3.13. Yetkilendirme</Typography>
          <Typography>
            <strong>3.13.1. </strong>Gerçekleştirilmeleri öncesinde tüm Ödemeler
            yetkilendirilmelidir. Ödeme Emirleri, Müşteri tarafından, UPT tarafından verilen
            talimatlar takip edilerek Ödeme Emrinin doğrulanmasıyla yetkilendirilir.
          </Typography>
          <Typography>
            <strong>3.13.2. </strong>Ödemeyi yetkilendirmek için Müşteri tarafından
            Kişiselleştirilmiş Güvenlik Özellikleri kullanılacaktır; başka bir ifadeyle, uzun süreli
            şifre ve SMS yoluyla alınacak tek seferlik şifre girilecektir. Kişiselleştirilmiş
            Güvenlik Özellikleri ile ilgili olarak Müşteri aşağıdaki hususları yerine getirmekle
            yükümlü olacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              UPT tarafından verilen talimatlara uygun olarak Kişiselleştirilmiş Güvenlik
              Özelliklerinin kullanılması. Müşteri tarafından bu tür talimatlara riayet edilmemesi
              halinde, bu husus ile bağlantılı her türlü zarar ve ziyadan Müşteri sorumlu olacaktır;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Kişiselleştirilmiş Güvenlik Özelliklerinin üçüncü taraflarca hiçbir şekilde erişilemez
              halde tutulması. Müşterinin
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Kişiselleştirilmiş Güvenlik Özelliklerinin güvenliğinin sağlanmasına ilişkin
              yükümlülüğü aynı zamanda, Kişiselleştirilmiş
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Güvenlik Özelliklerinin kaybedilmemesinin, çalınmamasının veya başka bir şekilde
              kötüye kullanılmamasının sağlanmasının yanı sıra, Kişiselleştirilmiş Güvenlik
              Özelliklerinin Ödeme Emirlerinin yetkilendirilmesine erişim sağlamak için gerekli olan
              veriler fiziki olarak elde edilmeksizin başka bir şekilde kopyalama veya elde etme
              amaçlı olarak kullanılmamasının sağlanmasına yönelik edimi de kapsamaktadır;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Kişisel Güvenlik Özelliklerinin kaybolması, çalınması veya başka bir şekilde kötüye
              kullanılması veya yetkisiz kullanımı ile ilgili olarak UPT'nin derhal haberdar
              edilmesi.
            </ListItem>
          </List>
          <Typography>
            <strong>3.13.3. </strong>UPT, güvenlik nedenleriyle gerekli görülmesi halinde,
            Kişiselleştirilmiş Güvenlik Özelliklerini bloke etme hakkına sahip olacaktır. Bu tür
            bloke etme, geçici veya daimî nitelikte olabilecektir. UPT, geçerli kanunlar kapsamında
            bu şekilde hareket etme hakkına sahip olduğu sürece, Hesap açılışı sırasında kullanılan
            kayıtlı e-posta adresine e-posta gönderilerek Müşteri söz konusu blokeler hakkında
            bilgilendirilecektir. Bloke etmeye ilişkin gerekçe sona erdiğinde bloke de
            kaldırılacaktır.
          </Typography>
          <Typography>
            <strong>3.13.4. </strong>UPT, Müşterinin Ödeme Emrinin doğrulanmasına yönelik olarak
            Müşteri tarafından ek işlemlerin yapılmasını talep etme hakkına sahiptir ve bu tür
            işlemler Hesapta doğrudan belirtilmeyebilecektir. UPT'nin bu hakkı kullanması durumunda,
            Müşteriye, UPT nezdinde kaydolmak için kullanılan adrese e-posta yoluyla talimat
            verilecektir. Hesap üzerinde gerçekleştirilen tüm yetkilendirmelerin Müşteri tarafından
            gerçekleştirildiği ve belgenin basılı kopyasındaki ıslak imzayla aynı yasal geçerliliğe
            sahip olduğu addedilecektir. Bu yetkilendirme, Ödemenin yetkilendirilmiş olduğunu
            kanıtlayan uygun kanıt aracı olarak değerlendirilecek ve bu durumda, Müşteri söz konusu
            Ödemeye itiraz etme hakkına sahip olmayacaktır.
          </Typography>
          <Typography>
            <strong>3.13.5. </strong>UPT’ye imza örnekleri verilmek suretiyle hesap üzerinde
            tasarrufa yetkili oldukları Müşteri tarafından bildirilmiş olan kimseler, aksi
            bildirilinceye kadar UPT tarafından tasarruf yetkilisi sayılacaklardır. Müşteri’nin ya
            da üçüncü kişinin yetki ve/veya ehliyetsizliğinden doğan bütün sonuçlar Müşteri’ye
            aittir. Ehliyetsizlik ve yetkisizlikler ile ilgili hususlar, yapılan değişiklikler,
            UPT’ye gerekli yasal belgeler ile birlikte, yazılı olarak ulaştırılmış olmadıkça UPT
            için bağlayıcı olmayacak ve UPT’ye bu yüzden hiçbir sorumluluk atfolunamayacaktır. UPT,
            anılan özel yazılı bildirim UPT’ye yapılmadıkça, Müşteri’yi ya da onun temsilcilerini
            tam ehliyetli ve her türlü tasarruf yetkisini haiz saymaya yetkili olup, bu yüzden
            sorumlu tutulamaz.
          </Typography>
          <Typography>
            <strong>3.13.6. </strong>Tutarların Hesaptan çıkarılmış olması ve Ödemenin Müşteri
            tarafından yetkilendirilmemiş olması halinde, UPT, en geç böyle bir yetkisiz Ödemenin
            gerçekleştirilmiş olduğundan haberdar hale geldiği günden sonraki İş Gününün sonuna
            kadar olmak üzere, uygulamada mümkün olan en kısa süre içerisinde aşağıdaki hususları
            yerine getirmekle yükümlü olacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Yetkilendirilmemiş Ödemenin tutarının Müşteriye geri ödenmesi ve
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT Ödeme Hesabındaki bakiyenin, söz konusu Ödeme gerçekleştirilmemiş gibi eski haline
              geri getirilmesi ve
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşteriye belirli bir vadeye ilişkin olarak faiz ödenmemesi veya müşteriden belirli
              bir vadeye ilişkin olarak faiz alınmaması (durum ne olursa olsun) ile ilgili olarak
              herhangi bir zarar ve ziyana uğramamasının sağlanması.
            </ListItem>
          </List>
          <Typography>
            <strong>3.13.7. </strong>Müşterinin Hesabında gerçekleştirilen tüm yetkisiz Ödemeler
            Müşteri tarafından UPT'ye bildirilmelidir.
          </Typography>
          <Typography variant="h4">4. Ücretler</Typography>
          <Typography>
            <strong>4.1. </strong>Ödeme Hizmetlerine uygulanacak ücretler Web Sitesinde yayınlanacak
            Tarifeler ve Koşullar kapsamında bildirilecektir. Ödeme İşlemleri ile ilgili olarak
            Müşteri tarafından Ödeme İşleminin her bir onaylanması sonrasında geçerli ücretler
            ekranda Müşteriye gösterilecektir.
          </Typography>
          <Typography>
            <strong>4.2. </strong>Aksi yazılı olarak kararlaştırılmadığı sürece, Müşteri, Ödeme
            Hizmetleri ve diğer hizmetler için UPT'ye, Tarifeler ve Koşullar kapsamında listelendiği
            şekilde ödeme yapmakla yükümlüdür.
          </Typography>
          <Typography>
            <strong>4.3. </strong>Müşteri tarafından Hesapta, söz konusu yükümlülüklerin muaccel
            hale geleceği tarihte UPT'ye karşı olan mali yükümlülüklerin yerine getirilmesi için
            yeterli Kullanılabilir Bakiye bulundurulmalıdır.
          </Typography>
          <Typography>
            <strong>4.4. </strong>Ödeme ile ilgili olarak ödenecek tüm Ücretler, Ödeme Emrinin
            yetkilendirilmesinden önce belirtilecektir. Sözleşmeyi imzalamakla Müşteri, UPT'yi
            Sözleşme süresi boyunca Ödeme Emirlerinin gerçekleştirilmesine ilişkin geçerli Ücretleri
            kesmek üzere yetkilendirmektedir. Geçerli ücretler Müşterinin Ödeme Emrinin
            gerçekleştirilmesine müteakiben kesilecektir. UPT tarafından aşağıda belirtilen,
            ödenmesi icap eden tutarlar müşteriye borç kaydedilir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme Hizmetlerine ilişkin Komisyon Ücretleri;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Ödeme İşlemlerine ilişkin Ücretler (Gelen/Giden Para Transferleri, UPT Gelen/Giden
              Kayıt Transferleri, vb.);
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Dış ticaret Ödeme İşlemlerine ilişkin Ücretleri;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>Döviz İşlemi Ücretleri;</ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Her ne ad altında veya şekilde olursa olsun, UPT'ye karşı olan diğer mali
              yükümlülükler.
            </ListItem>
          </List>
          <Typography>
            <strong>4.5. </strong>Müşteri, verilen Ödeme Emrinin gerçekleştirilmesine ilişkin olarak
            geçerli Ücretleri ödemek üzere Hesabında yeterli miktarda para bulunmasını sağlamakla
            yükümlüdür. Sözleşmeyi imzalamakla Müşteri, Hesabında yeterli miktarda para olmaması
            halinde UPT'nin Müşterinin Ödeme Emrini reddetme hakkına sahip olacağını anladığını
            beyan ve taahhüt etmektedir.
          </Typography>
          <Typography>
            <strong>4.6. </strong>Ödenmesi icap eden tutar, UPT'nin kendi takdir hakkı ve yetkisi
            doğrultusunda Müşterinin başka bir Hesabına borç kaydetme hakkı saklı kalmak kaydıyla
            borç kaydedilecektir. Hesapta söz konusu para birimi cinsinden tutarın mevcut olmaması
            halinde, gerekli tutar, UPT tarafından Ana Para Biriminden veya Hesapta bulunan başka
            bir para biriminden çevrilir. Çevrim, Ödeme İşleminin gerçekleştirildiği anda UPT'nin
            yürürlükte olan döviz kurlarına dayalıdır. Hesapta para bulunmaması veya borç
            kaydedilmek üzere yeterli paranın bulunmaması halinde, UPT, bu tutarları ilgili
            hesaplarda mevcut olan seçtiği herhangi bir diğer para birimi de dahil olmak üzere, aynı
            Müşterinin diğer hesaplarına borç kaydetme hakkına sahiptir.
          </Typography>
          <Typography>
            <strong>4.7. </strong>UPT Hizmetlerine ilişkin ücretler Müşteri Hesabından kesilir.
            Hesaptaki tutarların Ödeme Emrinde belirtilen tutardan ve UPT Hizmetinin fiyatından
            düşük olması halinde Ödeme Transferi gerçekleştirilmeyecektir.
          </Typography>
          <Typography>
            <strong>4.8. </strong>Borç kaydedilen tutarlar Müşteri tarafından Ekstrede ve/veya Web
            Sitesi vasıtasıyla kontrol edilebilir.
          </Typography>
          <Typography>
            <strong>4.9. </strong>Ödeme Hizmetleri Belgeleri kapsamında UPT'ye yapılacak tüm
            ödemeler, mahsup, kesinti veya karşı talep olmaksızın hesaplanacak ve yapılacaktır.
          </Typography>
          <Typography>
            <strong>4.10. </strong>Aksi açık bir şekilde belirtilmediği sürece, herhangi bir Ödeme
            Hizmetleri Belgesinde belirtilen veya ifade edilen ve UPT'ye ödenmesi icap eden tüm
            tutarlar katma değer vergisinden hariçtir. Katma değer vergisinin uygulanması halinde,
            Müşteri tarafından UPT'ye (asıl tutara ilaveten ve asıl tutarın ödenmesi ile aynı
            zamanda) bu verginin tutarına eşit olan tutar ödenecektir. Ödeme ile ilgili olarak
            ödenmesi icap eden bilcümle ücretler, Ödeme Emrinin yetkilendirilmesi öncesinde
            belirtilecektir.
          </Typography>
          <Typography>
            <strong>4.11. </strong>Hesap açılış ve işletim ücretleri, Web Sitesinde yer almakta olan
            Tarifeler ve Koşullar kapsamında bildirilir. Ödeme Transferlerinin
            gerçekleştirilebileceği bankaların ve elektronik ödeme sistemlerinin listesinin yanı
            sıra transferler için uygulanan Komisyon Ücretleri ve koşullar da burada
            belirtilmektedir.
          </Typography>
          <Typography>
            <strong>4.12. </strong>Müşterinin UPT Ödeme Hesabından Müşterinin banka hesabına,
            kartına veya başka bir elektronik ödeme sistemindeki elektronik para hesabına para
            transferi yapılmasının yanı sıra herhangi bir banka hesabından veya başka bir elektronik
            ödeme sisteminden UPT Ödeme Hesabına para transferi yapılması için herhangi bir banka
            veya başka bir Elektronik Para transferi sistemi tarafından Ücretler uygulayabilecektir.
          </Typography>

          <Typography variant="h4">5. Fikri Mülkiyet Hakları</Typography>
          <Typography>
            <strong>5.1. </strong>UPT tarafından Müşteriye Hizmet sunmak üzere gerekli olan
            yazılımın ve/veya uygulamaların mülkiyeti UPT'ye (veya halin icabına göre UPT'nin ana
            şirketi olan Aktif Yatırım Bankası A.Ş.'ye) ait olacaktır. Yazılıma ve herhangi bir
            diğer uygulamaya ilişkin olabilecek mülkiyet hakları ve diğer fikri mülkiyet hakları,
            münhasıran UPT Elektronik Para ve Ödeme Hizmetleri A.Ş. 'ye ait olacaktır.
          </Typography>
          <Typography>
            <strong>5.2. </strong>Müşteriye, herhangi bir Ödeme Hizmetine ilişkin olarak UPT
            tarafından sağlanan yazılımı kullanmak ve yüklemek üzere tamamen kişisel, gayri münhasır
            ve devredilemeyen bir lisans verilmektedir. Bununla birlikte, Müşteriye herhangi bir
            mülkiyet veya fikri hak devredilmemektedir. Bu lisans sadece, işbu Koşullar kapsamında
            belirtilen amaçlara uygun olarak ve UPT tarafından aksi belirtilmediği sürece, yazılımın
            Müşterinin bilgisayarına kurulması ve herhangi bir Ödeme Hizmetine ilişkin olarak
            kullanılması hakkını vermektedir ve Müşterinin herhangi bir Ödeme Hizmetini kullanmaya
            yetkili olduğu süre ile sınırlıdır.
          </Typography>
          <Typography>
            <strong>5.3. </strong>Mülkiyet, telif hakları ve fikri mülkiyet hakları da dahil olmak
            üzere, UPT ürünlerinin yanı sıra, sunulan bilcümle bilgilere, tavsiyelere ve/veya
            (diğer) hizmetlere ilişkin bilcümle haklar UPT'ye ve UPT'ye kullanım hakkını vermiş olan
            şahsa ait olacaktır.
          </Typography>
          <Typography>
            <strong>5.4. </strong>Müşteri tarafından UPT ürünlerinin (ürünlerin içeriğinin)
            değiştirilmesine, kopyalanmasına, dağıtılmasına, devredilmesine, görüntülenmesine,
            yayınlanmasına, satılmasına veya lisanslandırılmasına ya da söz konusu ürünlerden elde
            edilen herhangi bir çalışmanın üretilmesine veya kullanılmasına ya da herhangi bir UPT
            mobil uygulamasından veya Web Sitesinden herhangi bir bağlantı, bağlantılı metin veya
            derin bağlantı oluşturulmasına izin verilmemektedir.
          </Typography>
          <Typography>
            <strong>5.5. </strong>UPT'ye ait olan ve UPT ürünlerinde görünen ticaret unvanları,
            markalar ve logolar (veya bunlara benzer işaretler), UPT'nin mülkiyetindedir. Müşteri
            tarafından UPT'nin önceden yazılı izni olmaksızın söz konusu ticari unvanların,
            markaların ve logoların kullanılmasına izin verilmemektedir.
          </Typography>
          <Typography>
            <strong>5.6. </strong>GÖHS'nin işbu 5. maddesinde belirtilen yukarıdaki hallerden
            herhangi birinin mevcudiyeti halinde, Müşteri, UPT'nin söz konusu hale ilişkin olarak
            uğradığı doğrudan ve dolaylı zarar ve ziyanı tazmin etmekle yükümlü olacaktır. Mezkur
            hükme bakılmaksızın, böyle bir hal, GÖHS'nin esaslı ihlalini teşkil edecek ve UPT'ye
            GÖHS'yi ve söz konusu feshe ilişkin GÖHS koşullarına bakılmaksızın GÖHS'nin ayrı bir
            parçası olarak değerlendirilen ve Müşteri ile imzalanabilecek diğer sözleşmeleri derhal
            geçerli olacak şekilde fesih etme ve UPT tarafından fikri mülkiyetinin korunması ve UPT
            tarafından başka zarara ve ziyana uğranmasının önlenmesi için gerekli sayılması halinde
            Müşterinin Hesabına, diğer yazılımlara ve/veya uygulamalara erişimi bloke etme hakkı
            verecektir.
          </Typography>

          <Typography variant="h4">6. Gizlilik</Typography>
          <Typography>
            <strong>6.1. </strong>Taraflar, söz konusu bilgilerin nasıl elde edildiğine
            bakılmaksızın, Taraflar arasındaki akdi ilişkiye ilişkin bilcümle bilgilere gizlilik
            çerçevesinde muamele etmekle yükümlü olacaklardır. Gizlilik yükümlülüğü, aksi yazılı
            olarak kabul edilmediği sürece ve ilgili Tarafça söz konusu bilgilerin kanunlar,
            düzenlemeler veya kamu otoritesi tarafından alınan herhangi bir karar gereğince
            açıklanmasının öngörüleceği haller veya söz konusu bilgilerin halihazırda kamuya açık
            olduğu ve bu durumun diğer Tarafça akdin ihlaline atfedilemeyeceği haller hariç olmak
            üzere geçerli olacaktır.
          </Typography>
          <Typography>
            <strong>6.2. </strong>Böyle bir açıklamanın, UPT tarafından GÖHS kapsamındaki
            yükümlülüklerinin ifa edilmesi için gerekli olması koşuluyla, UPT, Müşteri hakkındaki
            bilgileri üçüncü taraflara, alt yüklenicilere ve diğer şirketlere açıklama hakkına sahip
            olacaktır.
          </Typography>
          <Typography>
            <strong>6.3. </strong>GÖHS'nin ve/veya Taraflar arasındaki ilgili sözleşmelerin Müşteri
            tarafından esaslı olarak ihlal edilmesi neticesinde veya Müşteri tarafından
            Dolandırıcılığın kolaylaştırılmış veya Dolandırıcılığa yardımcı olunmuş ve
            Dolandırıcılığın teşvik edilmiş olması sebebiyle GÖHS'nin artık geçerli olmaması
            halinde, UPT, Müşteriyi ilgili makamlara bildirmekle yükümlü olabilecek ve bu bildirim,
            gizlilik yükümlülüğünün ihlali sayılmayacaktır.
          </Typography>

          <Typography variant="h4">7. İletişim</Typography>
          <Typography>
            <strong>7.1. </strong>UPT, kendi takdir hakkı ve yetkisi doğrultusunda, Sözleşmenin
            akdedildiği yönteme bakılmaksızın, Müşteri ile aşağıdaki yollardan biri veya daha
            fazlası ile iletişim kurma hakkına sahiptir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Yazılı olarak (e-posta yoluyla olması da dahil olmak, ancak bununla sınırlı kalmamak
              üzere); Sözlü olarak (telefon, konuşan bilgisayar veya metin mesajları yoluyla da
              dahil olmak, ancak bunlarla sınırlı kalmamak üzere) veya Elektronik olarak (herhangi
              bir İnternet linkinin eklentisi ile birlikte olsun veya olmasın, e-posta ve herhangi
              bir Kanal / Müşterinin Profili vasıtasıyla olması da dahil olmak, ancak bununla
              sınırlı kalmamak üzere);
            </ListItem>
          </List>
          <Typography>
            <strong>7.2. </strong>Müşterinin iletişim bilgileri, Müşteriden kendisi ile çalışmaya
            başlanması süreci sırasında alınacaktır. İletişim bilgilerindeki değişiklikler Müşteri
            tarafından UPT'ye en az beş İş Günü öncesinde bildirilerek iletilecektir.
          </Typography>
          <Typography>
            <strong>7.3. </strong>Müşteri, UPT ile aşağıdaki yollarla iletişim kuracaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin [destek@upt.com.tr] şeklindeki e-posta adresi kullanılarak UPT'ye e-posta
              gönderilmesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Profili üzerinden kullanılabilen sohbet aracı kullanılarak mesaj veya yazı
              yazılması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT ile 0850 724 08 78 Çağrı Merkezi hattı aracılığı ile iletişim kurulması.
            </ListItem>
          </List>

          <Typography variant="h4">8. İletişim Dili</Typography>
          <Typography>
            <strong>8.1. </strong>UPT ile Müşteri arasındaki iletişim Müşterinin tercihine bağlı
            olarak Türkçe veya İngilizce olarak gerçekleştirilecektir.
          </Typography>
          <Typography>
            <strong>8.2. </strong>UPT tarafından, Müşteriden gelen ve 8.1 sayılı Madde kapsamında
            kararlaştırılan dil dışındaki herhangi bir dilde olan iletişim-lerin ve belgelerin,
            masrafları Müşteriye ait olmak üzere yeminli tercüman tarafından Türkçeye veya
            İngilizceye tercüme edilmesi öngörülebilecektir.
          </Typography>

          <Typography variant="h4">9. Sorumluluk</Typography>
          <Typography>
            <strong>9.1. </strong>Ödeme Hizmetleri Belgelerinde belirtilen diğer sorumluluk
            sınırlamaları saklı kalmak üzere, UPT, Müşteriye karşı yalnızca ağır kusurlu ve/veya
            ihmalkâr davranışları sebebiyle Müşterinin uğrayacağı doğrudan zarar ve/veya ziyandan ve
            sadece, Sözleşmenin ihlali anında UPT tarafından öngörülebilecek nitelikte olan zarar ve
            ziyanla sınırlı olarak sorumlu olacaktır.
          </Typography>
          <Typography>
            <strong>9.2. </strong>UPT'nin sorumluluğunun Ödeme Hizmetleri Belgeleri, Ödeme
            Hizmetlerinin sunulması, haksız fiil veya herhangi bir başka husus esas alınarak ileri
            sürülüp sürülmesine bakılmaksızın, dolaylı veya netice kabilinden zarar ve ziyadan UPT
            sorumlu değildir.
          </Typography>
          <Typography>
            <strong>9.3. </strong>Müşteri, Sözleşmenin akdine ilişkin olarak Müşteri tarafından
            gerçekleştirilen bilcümle fiil ve eylemlerin geçerli kanuna uygun olacağını taahhüt
            etmektedir.
          </Typography>
          <Typography>
            <strong>9.4. </strong>UPT'ye sunulan verilerin, emirlerin ve belgelerin doğruluğundan
            tamamen Müşteri sorumludur.
          </Typography>
          <Typography>
            <strong>9.5. </strong>Aşağıdakilerin yerine getirilmemesi sebebiyle ortaya çıkan
            yetkisiz Ödemelere ilişkin bilcümle zarar ve ziyan Müşteriye ait olacaktır:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin kasti suiistimali veya ağır ihmali veya Müşterinin haksız bir şekilde
              hareket etmesi nedeniyle Müşteri tarafından Kişiselleştirilmiş Güvenlik Özelliklerinin
              kullanım kurallarına riayet edilmesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Kişiselleştirilmiş Güvenlik Özelliklerinin kaybolması, çalınması veya kötüye
              kullanılması halinde UPT'nin mümkün olan en kısa süre içerisinde derhal haberdar
              edilmesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşterinin Kişiselleştirilmiş Güvenlik Özelliklerinin korunmasına ilişkin UPT
              talimatlarının takip edilmesi.
            </ListItem>
          </List>

          <Typography variant="h4">10. Web Sitesinin Kullanılması</Typography>
          <Typography>
            <strong>10.1. </strong>UPT, Web Sitesinin daima kullanılabilir, kesintisiz veya eksiksiz
            olacağını taahhüt etmemektedir. Web Sitesinde yer alan bilgiler tavsiye teşkil etmez.
          </Typography>
          <Typography>
            <strong>10.2. </strong>Müşteri, Web Sitesi teknik şarta haiz donanımlarla kullanacağını
            kabul eder. Ayrıca, Müşteri UPT tarafından kendisine bildirilen veya tavsiye edilen ilke
            ve “güvenlik kurallarına uyacağını, doğabilecek riskleri bildiğini, kullanıcı kodu ve
            şifrelerinin virüslü programlarla ele geçirilebileceğini, bu nedenle işlem yaparken anti
            virus programları dahil, teknolojik gelişmeler çerçevesinde gerekli her türlü güvenlik
            önlemini almadığı takdirde, doğabilecek tüm zararlardan sorumlu olacağını, kabul eder.
          </Typography>
          <Typography>
            <strong>10.3. </strong>Elektronik iletişimlerin teslim edilmemesinden veya elektronik
            iletişimlerin teslim edilmesindeki gecikmelerden, elektronik iletişimlerin üçüncü
            taraflarca veya elektronik iletişimler için kullanılan bilgisayar programları tarafından
            engellenmesinden veya manipülasyonundan ve Virüslerin iletilmesinden kaynaklanan zarar
            ve ziyan da dahil olmak, ancak bunlarla sınırlı kalmamak üzere, elektronik iletişim
            araçlarının kullanılmasından kaynaklanan zarar ve ziyadan UPT sorumlu olmayacaktır.
          </Typography>
          <Typography>
            <strong>10.4. </strong>Web Sitesinde, herhangi bir üçüncü tarafça çalıştırılan harici
            İnternet sitelerine bağlantılar verilebilecek veya söz konusu sitelerde Web Sitesine
            bağlantılar yer alabilecektir. Bu tür üçüncü taraf İnternet sitelerinin
            çalıştırılmasından, kullanılmasından veya içeriğinden UPT sorumlu olmayacaktır.
          </Typography>
          <Typography>
            <strong>10.5. </strong>Müşteri, tüzel kişiliğini temsile yetkili kişilerin bildirdiği
            kişi/kişilerin her türlü elektronik para transferi ve ödeme işlemi dahil tüm işlemleri
            yapmaya, tasarrufta bulunmaya tam yetkili olduklarını ve bu yetkiye dayanılarak veya Web
            Sitesi üzerinden UPT tarafından bildirilen şifre ve güvenlik adımları kullanılarak
            yapılan bütün işlemlerin Müşteri’yi bağlayıcı olduğunu, şifrelerin imza yerine
            geçtiğini, kabul ve taahhüt etmektedir. UPT’nin, Müşteri tarafından yetkilendirilen,
            Müşteri’nin nam ve hesabına, elektronik para transferi işlemi yapan, talimat veren,
            tasarrufta bulunan kişi/kişilerin, daha önce UPT’ye bildirilmiş olsa da kimliğini ve
            yetkilerini araştırması mümkün olmayıp Müşteri, şifrenin yetkisiz kişilerce kullanılması
            neticesinde doğabilecek zararlardan UPT’nin sorumlu olmayacağını ve UPT’ye ibra ettiğini
            taahhüt etmektedir.
          </Typography>

          <Typography variant="h4">11. Tazminat</Typography>
          <Typography>
            <strong>11.1. </strong>Aşağıdakilerden veya aşağıdakilerle bağlantılı olarak UPT
            aleyhine doğan bilcümle doğrudan, dolayı ve/veya netice kabilinden zarar, ziyan, gider
            ve masraflar (mahkeme masrafları da dahil) karşısında UPT, Müşteri tarafından
            Müşteri’nin talebine istinaden derhal, nakden ve defaten tazmin edilecektir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Müşteri tarafından UPT'ye borçlu olunan tutarların tahsil edilmesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>Hesabın haczi ve/veya ihtiyati haczi;</ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin ağır ihmali veya kastıyla sebebiyet vermediği sürece, Ödeme Hizmetlerine
              ilişkin olarak üçüncü taraflarca UPT aleyhine ileri sürülen hak talepleri;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşteri tarafından Ödeme Hizmetleri Belgelerinin koşullarından herhangi birine riayet
              edilmemesi;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşteri tarafından dolandırıcılık yapılması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT’nin yazılı onayı olmadan, Müşterinin Uluslararası Ödeme Transfer Sistemi’ni üçüncü
              kişilerin kullanımına sunması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Müşteri tarafından Kullanıcıya veya herhangi bir üçüncü taraf tarafından Müşteriye
              verilen vekaletnamenin ve/veya böyle bir vekaletname tahtında gerçekleştirilen
              herhangi bir işlemin geçersiz olması, bağlayıcı olmaması veya uygulanamaz olması.
            </ListItem>
          </List>

          <Typography variant="h4">12. Mücbir Sebep</Typography>
          <Typography>
            <strong>12.1. </strong>Mezkûr hükümlere bakılmaksızın, UPT'nin kontrolü dışındaki
            koşullar ile bağlantılı olarak yükümlülüklerine riayet edilmemesi neticesinde altına
            girilen zarar ve ziyandan UPT sorumlu olmayacaktır. Daha katı sorumluluk kurallarının
            geçerli olduğu yerlerde dahi, aşağıdakiler neticesinde altına girilen zarar ve ziyadan
            UPT sorumlu tutulamaz:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              BT sistemlerinin işletilmesinden UPT'nin veya herhangi bir üçüncü tarafın sorumlu
              olmasına bakılmaksızın, BT sistemlerinin arızalanması, BT sistemlerine erişilememesi,
              aşağıda sıralanan sebeplerden herhangi biri neticesinde BT sistemlerinde muhafaza
              edilen verilerin zarar görmesi,
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              UPT'nin telekomünikasyon sistemlerindeki herhangi bir güç kaynağı kesintisi veya
              arıza, mevzuata dayalı veya idari müdahaleler, doğal afetler, savaş, ihtilal, sivil
              itaatsizlik, sabotaj, terör veya yıkıcı eylemler (virüs saldırıları ve bilgisayar
              korsanlığı da dahil),
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Çatışmanın UPT'ye karşı yönlendirildiğine veya UPT veya UPT'nin organizasyonu
              tarafından başlatıldığına ve çatışmanın sebebine bakılmaksızın, grevler, lokavtlar,
              boykotlar veya ablukalar. Mezkûr hüküm, çatışmanın UPT'nin sadece belirli bir kısmına
              ve UPT'nin kontrolü dışındaki diğer koşullara etki etmesi halinde de geçerlidir.
            </ListItem>
          </List>
          <Typography>
            <strong>12.2. </strong>Mücbir Sebep halinde UPT'nin sorumluluktan muaf tutulması
            aşağıdaki hallerde geçerli değildir:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 3 }}>
            <ListItem sx={{ display: "list-item" }}>
              Müşteri ile Sözleşmenin yapıldığı tarihte, söz konusu zarar ve ziyana sebebiyet veren
              koşulların UPT tarafından önceden görülmüş olmasının gerekli olması veya uygun ticari
              önlemlerin alınması suretiyle UPT tarafından söz konusu zarar ve ziyanın sebebinin
              veya bunun sonuçlarının UPT tarafından engellenmesinin veya üstesinden gelinmesinin
              gerekli olması;
            </ListItem>
            <ListItem sx={{ display: "list-item" }}>
              Mevzuat kapsamında her durumda zarara ve ziyana sebebiyet veren koşullardan UPT'nin
              sorumlu kılınması.
            </ListItem>
          </List>

          <Typography variant="h4">13. Fesih</Typography>
          <Typography>
            <strong>13.1. </strong>GÖHS'ye ve Sözleşmeye uygun olarak fesih sonrasında Taraflar
            arasında Sözleşme imzalanıncaya kadar Ödeme Hizmetlerinin sunulmasına ilişkin olarak
            Müşterinin UPT ile akdi ilişki içerisinde olduğu ve GÖHS'nin Müşteri için yürürlükte
            olduğu addedilecektir.
          </Typography>
          <Typography>
            <strong>13.2. </strong>Müşteri, Sözleşmenin imza tarihini izleyen 30 (otuz) takvim
            günlük bir süre içerisinde Sözleşmeyi herhangi bir ek bedel olmadan feshetme hakkına
            sahip olacaktır. Müşteri tarafından işbu Madde kapsamında belirtilen şekilde Sözleşmenin
            fesih edilmesinin istenmesi halinde, Müşteri tarafından UPT'ye e-posta yoluyla feragat
            bildirimi gönderilmelidir. Feragat bildiriminde en azından şu bilgilere yer
            verilmelidir: Müşterinin ticari unvanı, kişisel kodu (verilmiş ise), tescil/kuruluş
            tarihi, , yasal şirket merkezi adresi ve Sözleşmenin tarihi ve numarası ve feragat
            bildirimi imzalanmalıdır. Feragat bildirimine ilişkin gerekliliklere riayet edilmemesi
            feragat bildiriminin reddedilmesi ile sonuçlanacaktır. Gerekli verilerin ve bilgilerin
            belirtilmesinden ve söz konusu verilerin doğru ve tam olmasının sağlanmasından Müşteri
            tek başına sorumludur. Müşteri, bu şekilde hareket edilmemesinin Müşteri tarafından
            Sözleşmeden feragat etme hakkının kullanılabileceği sürenin sona ermesi ile
            sonuçlanabileceğini idrak etmektedir. Sözleşmeyi imzalamakla Müşteri, Sözleşmenin işbu
            hükme uygun olarak feshi halinde, feragat bildiriminin tesellüm edilmesi öncesinde
            Müşteri için sunulan Hizmetler için Sözleşme kapsamında Müşteri tarafından UPT'ye
            ödenmiş bulunan ücretlerin Müşteriye geri ödenmeyeceğini idrak ettiğini beyan ve taahhüt
            etmektedir.
          </Typography>
          <Typography>
            <strong>13.3. </strong>UPT, Müşteriye en az 30 (otuz) gün önceden yazılı bir fesih
            bildiriminde bulunmak suretiyle Sözleşmeyi feshetme hakkına sahip olacaktır.
          </Typography>
          <Typography>
            <strong>13.4. </strong>UPT, geçerli yasal düzenlemeler kapsamında bu şekilde öngörülmesi
            halinde (örneğin, kara paranın aklanmasının önlenmesine veya terörizmin finansmanının
            önlenmesine yönelik gerekliliklere, uluslararası yaptırım gerekliliklerine bağlı olarak)
            Sözleşmeyi derhal geçerli olmak üzere fesih etme hakkına sahip olacaktır.
          </Typography>
          <Typography>
            <strong>13.5. </strong>Müşteri, Sözleşmenin herhangi bir gerekçeyle feshine ilişkin
            olarak UPT tarafından maruz kalınan doğrudan ve dolaylı tüm zarar ve ziyanın tazmin
            edilmesinden sorumlu olacaktır.
          </Typography>
          <Typography>
            <strong>13.6. </strong>Sözleşmenin feshi halinde, Müşterinin Hesabında tutulan tutarlar
            Müşterinin banka hesabına veya Müşteri tarafından belirtilen başka bir elektronik ödeme
            sistemindeki hesaba transfer edilecektir. UPT, Müşteri tarafından UPT'ye, devlet
            makamlarına veya üçüncü taraflara ödenmesi icap eden tutarı, UPT tarafından Müşterinin
            kusuru sebebiyle altına girilen bilcümle ödenmemiş cezai şartları, zarar ve ziyanı ve
            diğer tutarları Hesaptan tenzil etme hakkına sahip olacaktır. UPT Ödeme Hesabında
            yeterli tutarın mevcut olmaması halinde, Müşteri, vakit geçirmeksizin, ancak en geç
            UPT'nin yazılı talebini izleyen 5 (beş) İş Günü içerisinde olmak üzere, ilgili tutarları
            Müşterinin UPT Ödeme Hesabına alacak kaydedeceğini taahhüt etmektedir. UPT'nin kendi
            kontrolü dışındaki nedenlerden dolayı Müşteriye parayı geri ödeyememesi halinde,
            Müşteriye bu hususta derhal bildirimde bulunulacaktır. Müşteri tarafından derhal başka
            bir hesabı belirtilecek veya paranın geri ödenmesi (Ödemenin gerçekleştirilmesi) için
            gerekli ek bilgiler iletilecektir.
          </Typography>
          <Typography>
            <strong>13.7. </strong>Sözleşmenin feshi, Müşteriyi Sözleşmenin feshinden önce ortaya
            çıkan tüm sorumlulukların gereğince yerine getirilmesinden kurtarmayacaktır.
          </Typography>
          <Typography>
            <strong>13.8. </strong>Sözleşmenin feshi halinde dahi, Sözleşme, Sözleşmenin sona erdiği
            anda ödenmemiş alacaklara ilişkin olarak geçerli kalmaya devam edecektir.
          </Typography>
          <Typography>
            <strong>13.9. </strong>UPT, Müşteri’nin 2.2.3, 3.1.6. ve 3.11.1 maddelerine aykırı
            hareket etmesi halinde Sözleşmeyi derhal geçerli olmak üzere fesih etme hakkına sahip
            olacaktır. Müşteri, UPT tarafından maruz kalınan doğrudan ve dolaylı tüm zarar ve
            ziyanın tazmin edilmesinden sorumlu olacaktır.
          </Typography>

          <Typography variant="h4">
            14. Dolandırıcılık ve Güvenlik Tehditlerine ilişkin Bildirim
          </Typography>
          <Typography>
            <strong>14.1. </strong>Hizmetlerin sunulması ile ilgili verilerin kötüye kullanılması,
            şüphelenilen veya gerçekleştirilen Dolandırıcılık veya güvenlik tehdidi halinde, Müşteri
            UPT tarafından kayıtlı e-postası, telefon ve/veya diğer telekomünikasyon imkanları
            yoluyla bilgilendirilecektir. Müşterinin kimliğinin gerektiği şekilde tespit
            edilebilmesi için UPT tarafından Müşteriden UPT'ye UPT tarafından bilinen verilerin
            iletilmesi talep edilebilecektir. Müşterinin, Dolandırıcılık ve/veya Güvenlik Tehdidi
            ile ilgili olarak telefon yoluyla bilgilendirilmesi halinde bu telefon görüşmesi kayıt
            altına alınacaktır. UPT, herhangi bir Dolandırıcılık ve/veya Güvenlik Tehdidinin bulunup
            bulunmadığını ortaya çıkarmak için gereken süre boyunca UPT Ödeme Hesabının kullanımını
            ve Müşterinin Ödeme Emirlerinin veya Ödemelerinin gerçekleştirilmesini askıya alma
            hakkına sahip olacaktır.
          </Typography>
          <Typography>
            <strong>14.2. </strong>Sözleşmenin amacı doğrultusunda, güvenlik tehdidi, bilgi ve
            iletişim teknolojisi (BİT) sistemlerinin ve/veya ödeme hizmeti bilgilerinin
            kullanılabilirliği, bütünlüğü ve gizliliği üzerinde olumsuz etkisi olan veya olumsuz
            etkisi olabilecek eksik veya yetersiz iç süreçler veya dış olaylar riski olarak
            tanımlanacaktır. Siber saldırılar veya güvensizlik ile ilişkili riskler buna dahildir.
          </Typography>

          <Typography variant="h4">15. Gizlilik ve Verilerin Korunması</Typography>
          <Typography>
            <strong>15.1. </strong>Hesabın kullanıcı adının ve şifresinin daima güvende tutulması ve
            üçüncü taraflara asla açıklanmaması için gerekli tüm tedbirler Müşteri tarafından
            alınmalıdır. UPT tarafından Müşteriden Müşterinin şifresini veya kullanıcı adının UPT'ye
            veya herhangi bir üçüncü tarafa açıklanması asla talep edilmeyecektir.
          </Typography>
          <Typography>
            <strong>15.2. </strong>Şifrenin kaybedilmesi veya şifrenin (şifrelerin) Müşterinin veya
            UPT'nin kusuru dışında açıklanması veya Müşterinin Profiline yönelik olarak gerçek bir
            tehdidin ortaya çıkması veya ortaya çıkabilecek olması halinde, Müşteri, şifreyi derhal
            değiştireceğini veya Müşterinin şifreyi değiştirmesinin mümkün olmaması halinde, UPT'ye
            bu hususa ilişkin olarak derhal (en geç bir takvim günü içerisinde) bildirimde
            bulunacağını taahhüt etmektedir. Bildirimde bulunulmaması sebebiyle doğabilecek
            sonuçlardan UPT sorumlu olmayacaktır.
          </Typography>
          <Typography>
            <strong>15.3. </strong>GÖHS kapsamında belirtildiği şekilde UPT tarafından Müşteriden
            bildirimin alınması sonrasında, UPT tarafından Müşteri için yeni bir şifre iletilinceye
            veya oluşturuluncaya değin Müşterinin Profiline erişim ve UPT hizmetlerinin sunumu
            derhal askıya alınacaktır.
          </Typography>
          <Typography>
            <strong>15.4. </strong>Müşteri tarafından şifrenin veya diğer giriş bilgilerinin Web
            Sitesi veya Mobil Uygulama dışındaki herhangi bir yerde açıklanmasına yönelik herhangi
            bir talebin alınması halinde, Müşteri tarafından Şifre veya diğer giriş bilgileri
            herhangi bir sebeple açıklanmamalı ve bu olay derhal UPT'ye bildirilmelidir.
          </Typography>
          <Typography>
            <strong>15.5. </strong>Müşteri tarafından bu yükümlülüğe riayet edilmemesi ve/veya
            riayet edilebilecek iken bunun önlenmemesi ve/veya kasten veya kendi ihmali dolayısıyla
            bu tür eylemlerde bulunulması halinde, Müşterinin belirtilen eylemleri veya eylemsizliği
            sebebiyle başka şahıslar tarafından altına girilen zarar ve ziyan tamamen Müşteriye
            aittir ve Müşteri bu zarar ve ziyanı tazmin etmeyi taahhüt etmektedir.
          </Typography>
          <Typography>
            <strong>15.6. </strong>Hesaptaki herhangi bir güvenlik ihlalinin azaltılabilmesi için
            UPT tarafından UPT Hesabının şifresinin düzenli olarak değiştirilmesi tavsiye
            edilmektedir. Aynı zamanda, UPT tarafından, herhangi bir kişi tarafından bilinebilen
            veya Müşteri hakkında elde edilebilen bilgilerden kolaylıkla saptanabilecek veya anlama
            sahip olan bir şifrenin seçilmemesi tavsiye edilmektedir. Müşteri tarafından hiç
            kimsenin Hesaba erişmesine veya Hesaba erişilmesi sırasında hiç kimsenin bunu izlemesine
            izin verilmemelidir.
          </Typography>
          <Typography>
            <strong>15.7. </strong>Müşterinin cep telefonu numarası ve e-posta adresi, Ödemeyi
            yetkilendirmek üzere tek seferlik pin kodlarının gönderilmesi için kullanılacak
            olduğundan veya şifreleri sıfırlamak veya UPT Ödeme Hesabının güvenliği ile ilgili
            olarak Müşteri ile iletişim kurmak için kullanılabilecek olduğundan dolayı, Hesaba giriş
            yapmak için kullanıcı kimliği olarak kullanılan cep telefonu numarasının (ayrıca, tek
            seferlik şifre gönderimi için kullanılacaktır), e-posta adresinin ve uzun süreli
            şifresinin güvenli ve yalnızca Müşteri tarafından erişilebilir nitelikte olmasını
            sağlamak üzere Müşteri tarafından tüm makul özen gösterilmelidir. Cep telefonu
            numarasının ve e-posta adresinin ele geçirilmesi durumunda Müşteri tarafından UPT derhal
            bilgilendirilmelidir.
          </Typography>
          <Typography>
            <strong>15.8. </strong>Müşteri tarafından Hesaba erişim sağlamak için herkese açık,
            paylaşılan veya kendi bilgisayarının kullanıp kullanmadığına bakılmaksızın, Müşteri
            daima Müşterinin giriş bilgilerinin tarayıcı tarafından saklanmadığından veya ön belleğe
            alınmadığından veya başka bir şekilde kaydedilmediğinden emin olunmalıdır. Müşteri
            tarafından giriş bilgilerinin veya şifrelerin Müşterinin kullandığı bilgisayarda
            saklanmasına izin veren hiçbir işlev kesinlikle kullanılmamalıdır.
          </Typography>
          <Typography>
            <strong>15.9. </strong>UPT, Müşteri ile gerçekleştirilen telefon görüşmelerini kaydetme
            hakkına sahiptir. Taraflar, telefon görüşmelerinin ve posta, e-posta ve diğer
            telekomünikasyon araçları yoluyla aktarılan mesajların Taraflar arasındaki
            uyuşmazlıkların çözüme kavuşturulmasında delil sayılabileceğini kabul etmektedirler.
            İşbu Sözleşmeyle Müşteri, kendisi veya temsilcileri ile gerçekleştirilen telefon
            görüşmelerinin UPT tarafından kaydedileceğini anladığını ve kabul ettiğini teyit
            etmektedir. Müşteri aynı zamanda telefon görüşmelerini ve diğer yazışmaları kaydetme ve
            saklama hakkına sahiptir.
          </Typography>
          <Typography>
            <strong>15.10. </strong>Müşteri, kişisel verilerinin UPT'nin Müşteriye hizmet sunmak ve
            işbu Sözleşme kapsamındaki diğer sorumlulukları yerine getirmek amacıyla yönetileceğini
            kabul etmektedir. Taraflar, işbu Sözleşmenin akdedilmesi sırasında alınan kişisel
            verilerin güvenliğini ve kişisel verilerin işbu Sözleşmenin akdi/ifası için gerektiği
            ölçüde kullanılacağını garanti etmektedirler. Yukarıda belirtilen kişisel veriler, kanun
            veya işbu Sözleşme kapsamında belirtilen haller hariç olmak üzere, bu verilerin
            sahibinden onay alınmaksızın üçüncü taraflara açıklanamaz.
          </Typography>
          <Typography>
            <strong>15.11. </strong>Müşteri bu sözleşmeden doğan hukuki ilişki kapsamında UPT’ye
            verdiği/vereceği ortaklarına, imza yetkililerine, çalışanlarına ya da diğer gerçek
            kişilere ait kişisel verileri hukuka uygun olarak elde ettiğini, bunları UPT ile
            paylaşma konusunda yetki sahibi olduğunu kabul, beyan ve taahhüt eder. Müşteri, bu
            kişisel verilerin hukuka aykırı olarak elde edilmiş olması nedeniyle UPT’nin uğrayacağı
            her türlü zararı tazmin etmekle yükümlüdür.
          </Typography>
          <Typography>
            <strong>15.12. </strong>Veri saklama ve koruma hususları, Müşteri tarafından okunarak
            riayet edileceği taahhüt edilen, Sözleşmenin Ekini teşkil eden "Gizlilik Politikası"na
            tabidir.
          </Typography>
          <Typography>
            <strong>15.13. </strong>Müşteri, UPT'ye Müşterinin kimliğinin ve Müşteri tarafından
            sunulan diğer verilerin doğruluğunun tespit edilmesi amacıyla doğrudan üçüncü taraflara
            veya üçüncü taraflar vasıtasıyla taleplerde bulunulması da dahil olmak, ancak bununla
            sınırlı kalmamak, üzere gerekli tedbirleri alma hakkı vermektedir.
          </Typography>
          <Typography>
            <strong>15.14. </strong>Müşteri, Müşterinin Ödeme Hesabı numarasının ve Ödeme Transferi
            için gerekli olan kişisel verilerin tespit edilebileceğini ve başka bir UPT Müşterisinin
            Müşterinin teyit edilmiş tanımlayıcısını (ad, soyad, unvan, banka hesabı, e-posta
            adresi) girmesi halinde Müşteriye Ödeme Transferi gerçekleştirmeyi amaçlayan başka bir
            UPT Müşterisine gösterilebileceğini kabul etmektedir.
          </Typography>
          <Typography>
            <strong>15.15. </strong>Müşterinin onayıyla Müşterinin verileri ödeme başlatma veya
            hesap bilgileri hizmeti kurumlarına da iletilebilecektir. UPT tarafından, yetkisiz veya
            haksız Ödeme İşlemi başlatılması da dahil olmak üzere, hesap bilgileri hizmet
            sağlayıcısı veya ödeme başlatma hizmeti sağlayıcısı tarafından elde edilen Hesaba
            yetkisiz veya haksız bir şekilde erişime ilişkin olarak objektif ve usulüne uygun olarak
            gerekçelendirilmiş dayanaklara dayalı olarak hesap bilgileri hizmet sağlayıcılarına veya
            ödeme başlatma hizmeti sağlayıcısına Müşterinin Hesabına erişim imkanının sunulması
            reddedilebilecektir. Bu gibi hallerde, UPT tarafından Müşteri Hesaba erişim imkânın
            sunulmasının reddi hakkında bilgilendirilecek ve bu tür eyleme ilişkin sebepler
            belirtilecektir. Bu bilgilerin verilmesi emniyet tedbirlerini zayıflatmadığı veya
            mevzuat kapsamında yasaklanmadığı sürece, mümkün olması halinde Hesaba erişim izni
            verilmesinin reddedilmesinden önce ve en geç erişim izninin reddedilmesine müteakiben
            olmak üzere, bu bilgiler Müşteriye iletilmelidir.
          </Typography>
          <Typography>
            <strong>15.16. </strong>UPT, Müşteri ve Müşterinin faaliyetleri hakkında toplanan tüm
            önemli bilgileri diğer kolluk kuvvetlerine, devlet makamlarına ve mevzuat gereğince
            belirlenmesi halinde ve GÖHS'nin ve ilgili mevzuatın ihlal edilip edilmediğine veya
            edilmeyeceğine yönelik tespitte bulunmak amacıyla, diğer finansal kuruluşlara aktarma
            hakkına sahiptir.
          </Typography>

          <Typography variant="h4">16. Muhtelif Hükümler</Typography>
          <Typography variant="h4">16.1. Formların ve Formatların Kullanılması</Typography>
          <Typography>
            <strong> </strong>
          </Typography>
          <Typography>
            <strong>16.1.1. </strong>Ödeme Hizmetlerine ilişkin olarak Müşteri tarafından, mevcut
            ise, UPT tarafından sunulan veya belirtilen, usulüne uygun olarak doldurulan, okunaklı
            olan ve ıslak veya Elektronik İmza taşıyan (basılı, online veya elektronik) formların ve
            formatların veya uygulanabildiğinde UPT tarafından gerekli görülen herhangi bir diğer
            tanımlama şeklinin kullanılması gerekmektedir.
          </Typography>
          <Typography>
            <strong>16.1.2. </strong>UPT, formların (talimat formlarının) ve formatların geçersiz
            olduğunu beyan etme ve bu formları veya formatları değiştirmek hakkına sahiptir. Bu
            durumda UPT, geçersiz olduğu beyan edilen formlar veya formatlar ve kullanılacak yeni
            formlar veya formatlar hakkında Müşteriyi bilgilendirecektir. Geçersiz olduğu veya
            yanlış kullanıldığı beyan edilen formlar (talimat formları) veya formatlar sebebiyle
            Müşterinin uğradığı zarar ve/veya ziyandan UPT sorumlu olmayacaktır.
          </Typography>
          <Typography>
            <strong>16.1.3. </strong>UPT tarafından Ödeme Hizmetlerinin ve Ödeme İşlemlerinin
            emniyeti bakımından veya UPT tarafından kullandırılan formlar (talimat formları) veya
            formatlar kullanılarak verilenler dışındaki Ödeme Emirlerine ilişkin olarak formların
            (talimat formlarının) veya formatların kullanılmasına ilişkin özel ve/veya ek
            gereklilikler öngörülebilecektir.
          </Typography>

          <Typography variant="h4">16.2. Müşteri ve Üçüncü Taraflar</Typography>
          <Typography>
            <strong>16.2.1. </strong>Tüzel Müşteri’nin şirket esas sözleşmesindeki değişiklikler,
            işbu Sözleşmenin devamı süresince Müşteri’nin bu Sözleşme’den doğan sorumluluğunu
            etkilemeyeceği gibi Müşteri’yi de sorumluluktan kurtarmayacaktır.
          </Typography>
          <Typography>
            <strong>16.2.2. </strong>İşbu Sözleşme tahtında UPT nezdinde hesap açılışı sırasında
            ibraz edilen İmza Sirkülerinde yetkili gösterilen kişilerde veya yetkilerinde meydana
            gelecek herhangi bir değişiklik derhal yazılı olarak UPT’ye bildirilecek olup, yazılı
            bildirimin UPT’ye ulaşmasına kadar, ibraz edilen son İmza Sirkülerindeki yetkililerin
            yaptığı ve yapacağı işlemler geçerli ve bağlayıcı olmaya devam edecektir. Müşteri,
            Şirketin/Kuruluşun/Ortaklığın temsil ve ilzamında meydana gelen değişiklikler Ticaret
            Siciline tescil edilse ve Türkiye Ticaret Sicil Gazetesinde ilan edilse bile, UPT’ye
            yazılı olarak bildirilmedikçe, söz konusu değişikliğin UPT’ye karşı herhangi bir hüküm
            ifade etmeyeceğini kabul, beyan ve taahhüt eder.
          </Typography>
          <Typography>
            <strong>16.2.3. </strong>UPT, Müşteri ile herhangi bir üçüncü taraf arasındaki herhangi
            bir dayanak hukuki ilişkiye taraf olmayacaktır.
          </Typography>
          <Typography>
            <strong>16.2.4. </strong>Ödeme Hizmetleri Belgelerine taraf olmayan şahıslar, böyle bir
            belgeyi (böyle bir belgenin herhangi bir hükmünü) uygulama veya böyle bir belgeden
            (böyle bir belgenin herhangi bir hükmünden) yararlanma hakkına sahip değildir.
          </Typography>

          <Typography variant="h4">16.3. Delil</Typography>
          <Typography>
            <strong>16.3.1. </strong>Müşteri tarafından aksi yönde delil sunulmadığı sürece, UPT'nin
            kayıtlarında yer alan bilgilerin UPT ile Müşteri arasında kesin delil teşkil ettiği
            addedilir. UPT, kayıtlarını yasal kayıt tutma süresinin üzerinde bir süre boyunca
            saklamakla yükümlü değildir.
          </Typography>
          <Typography>
            <strong>16.3.2. </strong>Ekstreler, Ödeme Emirleri, UPT'nin ürünlerine ve hizmetlerine
            ilişkin duyurular ve raporlar da dahil olmak üzere UPT ve üçüncü taraflar arasındaki her
            şekilden iletişimin yanı sıra Müşteri ile UPT arasındaki herhangi bir diğer şekle sahip
            olan yazılı veya elektronik iletişimler UPT tarafından yazılı veya elektronik olarak
            çoğaltma ve/veya UPT'nin sisteminden iletişimin kopyasının alınması yoluyla
            kanıtlanabilir. Bu tür iletişimler ve bunların çoğaltmaları veya kopyaları, Müşteri
            tarafından aksi yönde delik sunulmadığı sürece, UPT ile Müşteri arasında kesin delil
            teşkil eder.
          </Typography>
          <Typography variant="h4">16.4. Alt Yüklenicilere Verme/Alt Sözleşme Yapma</Typography>
          <Typography>
            Ödeme Hizmetlerinin sunulmasında UPT tarafından üçüncü taraflardan yararlanılabilecek ve
            faaliyetler (kısmi olarak) alt yüklenicilere verme/alt sözleşme yoluyla
            gerçekleştirilebilecektir.
          </Typography>

          <Typography variant="h4">16.5. Vergiler ve harçlar</Typography>
          <Typography>
            Her ne ad altında olursa olsun ve her kim tarafından tarh edilirse edilsin, Müşteri ile
            UPT arasındaki ilişkiye ilişkin bilcümle vergiler ve harçlar Müşteri tarafından
            karşılanır. Kanunen veya mevzuat gereğince Müşterinin UPT'ye ödenmesi icap eden herhangi
            bir tutara stopaj uygulamak veya böyle bir tutardan herhangi bir meblağı tenzil etmek
            zorunda olması halinde, böyle bir stopajın veya tenzilatın öngörülmemiş olması halinde
            UPT tarafından tesellüm olunacak tutara ulaşılması için gerekli olan ilave tutarlar
            Müşteri tarafından ödenecektir.
          </Typography>

          <Typography variant="h4">16.6. İş Günü ve Çalışma Saatleri</Typography>
          <Typography>
            Müşteri, işbu Sözleşme’de belirtilen iş günleri dışında kalan günlerin UPT’nin kapalı
            olacağını ve UPT ile olan ilişkilerde bu günlerin iş günü olarak sayılmayacağını kabul
            eder. UPT’nin günlük çalışma saatlerini, yürürlükteki mevzuata uygun olması kaydıyla
            dilediği şekilde belirleme hakkı vardır.
          </Typography>

          <Typography variant="h4">17. Uygulanacak Hukuk ve Uyuşmazlıklar</Typography>
          <Typography variant="h4">17.1.1. Uygulanacak Hukuk</Typography>
          <Typography>
            GÖHS veya herhangi bir diğer Ödeme Hizmetleri Belgesi kapsamında aksi öngörülmediği
            sürece, Ödeme Hizmetleri Belgeleri ve bunlardan veya bunlar ile bağlantılı olarak doğan
            gayri akdi yükümlülükler de dahil olmak üzere, Hesaba ve Ödeme Hizmetine ilişkin olarak
            Müşteri ile UPT arasındaki ilişki Türkiye Cumhuriyeti kanunlarına tabi olacak ve yine
            Türkiye Cumhuriyeti kanunlarına uygun olarak yorumlanacaktır.
          </Typography>

          <Typography variant="h4">17.2. Uyuşmazlıklar</Typography>
          <Typography>
            <strong>17.2.1. </strong>UPT ile Müşteri arasındaki uyuşmazlıklar müzakere yoluyla
            çözüme kavuşturulacaktır.
          </Typography>
          <Typography>
            <strong>17.2.2. </strong>Müşteri, UPT'ye şikayetlerini iletme hakkına sahiptir.
            Şikayetler, UPT'ye [destek@upt.com.tr] e-posta adresi üzerinden e-posta bildirimi
            yoluyla iletilebilecektir.
          </Typography>
          <Typography>
            <strong>17.2.3. </strong>UPT tarafından Müşterinin şikayetlerine, ilgili şikayetin
            alındığı tarihten itibaren 15 İş Günü içerisinde yazılı olarak veya başka bir kalıcı
            ortam kullanılarak yanıt verilecektir. İstisnai hallerde, UPT'nin kontrolü dışındaki
            sebeplerden dolayı UPT tarafından Müşteriye gecikmeye ilişkin sebepler belirtilerek ve
            UPT'nin kesin yanıtınızın Müşteri tarafından alınacağı süre belirtilerek ön yanıt
            gönderilmesine izin verilecektir. Kesin yanıtın verilmesine ilişkin süre, UPT’nin
            kontrolü dışındaki sebeplerden dolayı olmadıkça, her halükârda şikâyetin alındığı
            tarihten itibaren en geç 35 (otuz beş) İş Gününü aşmayacaktır.
          </Typography>
          <Typography>
            <strong>17.2.4. </strong>Şikâyet yönetimi ücretsizdir. Taraflar, şikayetlerin Türkçe ve
            İngilizce olarak sunulacağını, yönetileceğini ve yanıtlanacağını kabul etmektedirler.
          </Typography>
          <Typography>
            <strong>17.2.5. </strong>UPT, şikayetlerin geçerli kanunlara uygun olarak adil bir
            şekilde ve hızlıca yönetilmesine yönelik iç prosedürlere sahip olacaktır.
          </Typography>
          <Typography>
            <strong>17.2.6. </strong>Taraflar arasında aksi kararlaştırılmadığı sürece, Müşterinin
            UPT'nin kesin yanıtından memnun olmaması halinde, Müşteri yalnızca mahkemelere başvurma
            yoluna gidecektir. Taraflar bu vesileyle işbu GÖHS'yi tamamen okuduklarını,
            anladıklarını ve kabul ettiklerini beyan, kabul ve taahhüt etmektedirler.
          </Typography>

          <Typography variant="h4">18. Gerçek Faydalanıcı Beyanı</Typography>
          <Typography>
            18 Ekim 2006 tarih ve 26322 sayılı Resmî Gazete’de yayınlanan “SUÇ GELİRLERİNİN
            AKLANMASININ ÖNLENMESİ HAKKINDA 5549 SAYILI KANUN”un 15. maddesinde tanımlanan anlamda
            “gerçek faydalanıcı” olduğumu ve UPT nezdinde bu sıfatla hesabı açtığımı ve bu Sözleşme
            kapsamında işlemleri kendi ad ve hesabıma yapacağımı beyan ederim. Kendi adıma ve fakat
            başkası hesabına hareket etmem halinde 5549 Sayılı Kanun ve bu kanunun alt
            düzenlemelerine uygun olarak kimin hesabına işlem yaptığımı ve bu kişinin kimlik
            bilgileri ile bu işlemler için yetkili durumunu, işlemin yapılmasından önce UPT’yi
            yazılı olarak bildireceğimi kabul ve beyan ederim.
          </Typography>
          <Typography>
            18 ana maddeden ve 29 sayfadan ibaret Sözleşme’yi tamamen okuduğumuzu, her sayfasını
            imzalamaya/paraflamaya gerek olmadığını, tüm Sözleşme hükümlerinin hakkımızda geçerli
            olacağını, işbu Sözleşme’nin 2 (iki) nüsha olarak düzenlendiğini ve imzalandığını ve bir
            nüshasının tarafımıza teslim edildiğini kabul ve beyan ederiz.
          </Typography>
        </Grid.Item>
      </Grid>
    </Box>);
}

    async function __Next_Translate__getStaticProps__1a16af5a8b0__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/agreement/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a16af5a8b0__ as getStaticProps }
  